import React, { useState, useEffect } from "react";
import { fetchCheckoutDisclaimer, CheckoutDisclaimer } from "../../../../../utils/checkoutDisclaimer";
import { Card, CardBody, Col, Row, Container, Form, FormGroup, Label, Input, Button, FormFeedback, Alert, UncontrolledTooltip } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";

const DEFAULT_COUNTRY = "US";
const DEFAULT_STATE = "VA";

const COUNTRY_OPTIONS = [
    { code: "US", label: "United States" },
    { code: "CA", label: "Canada" },
    { code: "AF", label: "Afghanistan" },
    { code: "AL", label: "Albania" },
    { code: "DZ", label: "Algeria" },
    { code: "AD", label: "Andorra" },
    { code: "AO", label: "Angola" },
    { code: "AG", label: "Antigua and Barbuda" },
    { code: "AR", label: "Argentina" },
    { code: "AM", label: "Armenia" },
    { code: "AU", label: "Australia" },
    { code: "AT", label: "Austria" },
    { code: "AZ", label: "Azerbaijan" },
    { code: "BS", label: "Bahamas" },
    { code: "BH", label: "Bahrain" },
    { code: "BD", label: "Bangladesh" },
    { code: "BB", label: "Barbados" },
    { code: "BY", label: "Belarus" },
    { code: "BE", label: "Belgium" },
    { code: "BZ", label: "Belize" },
    { code: "BJ", label: "Benin" },
    { code: "BT", label: "Bhutan" },
    { code: "BO", label: "Bolivia" },
    { code: "BA", label: "Bosnia and Herzegovina" },
    { code: "BW", label: "Botswana" },
    { code: "BR", label: "Brazil" },
    { code: "BN", label: "Brunei" },
    { code: "BG", label: "Bulgaria" },
    { code: "BF", label: "Burkina Faso" },
    { code: "BI", label: "Burundi" },
    { code: "CV", label: "Cabo Verde" },
    { code: "KH", label: "Cambodia" },
    { code: "CM", label: "Cameroon" },
    { code: "CF", label: "Central African Republic" },
    { code: "TD", label: "Chad" },
    { code: "CL", label: "Chile" },
    { code: "CN", label: "China" },
    { code: "CO", label: "Colombia" },
    { code: "KM", label: "Comoros" },
    { code: "CD", label: "Congo (DRC)" },
    { code: "CG", label: "Congo (Republic)" },
    { code: "CR", label: "Costa Rica" },
    { code: "CI", label: "Côte d’Ivoire" },
    { code: "HR", label: "Croatia" },
    { code: "CU", label: "Cuba" },
    { code: "CY", label: "Cyprus" },
    { code: "CZ", label: "Czech Republic" },
    { code: "DK", label: "Denmark" },
    { code: "DJ", label: "Djibouti" },
    { code: "DM", label: "Dominica" },
    { code: "DO", label: "Dominican Republic" },
    { code: "EC", label: "Ecuador" },
    { code: "EG", label: "Egypt" },
    { code: "SV", label: "El Salvador" },
    { code: "GQ", label: "Equatorial Guinea" },
    { code: "ER", label: "Eritrea" },
    { code: "EE", label: "Estonia" },
    { code: "SZ", label: "Eswatini" },
    { code: "ET", label: "Ethiopia" },
    { code: "FJ", label: "Fiji" },
    { code: "FI", label: "Finland" },
    { code: "FR", label: "France" },
    { code: "GA", label: "Gabon" },
    { code: "GM", label: "Gambia" },
    { code: "GE", label: "Georgia" },
    { code: "DE", label: "Germany" },
    { code: "GH", label: "Ghana" },
    { code: "GR", label: "Greece" },
    { code: "GD", label: "Grenada" },
    { code: "GT", label: "Guatemala" },
    { code: "GN", label: "Guinea" },
    { code: "GW", label: "Guinea-Bissau" },
    { code: "GY", label: "Guyana" },
    { code: "HT", label: "Haiti" },
    { code: "HN", label: "Honduras" },
    { code: "HU", label: "Hungary" },
    { code: "IS", label: "Iceland" },
    { code: "IN", label: "India" },
    { code: "ID", label: "Indonesia" },
    { code: "IR", label: "Iran" },
    { code: "IQ", label: "Iraq" },
    { code: "IE", label: "Ireland" },
    { code: "IL", label: "Israel" },
    { code: "IT", label: "Italy" },
    { code: "JM", label: "Jamaica" },
    { code: "JP", label: "Japan" },
    { code: "JO", label: "Jordan" },
    { code: "KZ", label: "Kazakhstan" },
    { code: "KE", label: "Kenya" },
    { code: "KI", label: "Kiribati" },
    { code: "KP", label: "Korea (North)" },
    { code: "KR", label: "Korea (South)" },
    { code: "KW", label: "Kuwait" },
    { code: "KG", label: "Kyrgyzstan" },
    { code: "LA", label: "Laos" },
    { code: "LV", label: "Latvia" },
    { code: "LB", label: "Lebanon" },
    { code: "LS", label: "Lesotho" },
    { code: "LR", label: "Liberia" },
    { code: "LY", label: "Libya" },
    { code: "LI", label: "Liechtenstein" },
    { code: "LT", label: "Lithuania" },
    { code: "LU", label: "Luxembourg" },
    { code: "MG", label: "Madagascar" },
    { code: "MW", label: "Malawi" },
    { code: "MY", label: "Malaysia" },
    { code: "MV", label: "Maldives" },
    { code: "ML", label: "Mali" },
    { code: "MT", label: "Malta" },
    { code: "MH", label: "Marshall Islands" },
    { code: "MR", label: "Mauritania" },
    { code: "MU", label: "Mauritius" },
    { code: "MX", label: "Mexico" },
    { code: "FM", label: "Micronesia" },
    { code: "MD", label: "Moldova" },
    { code: "MC", label: "Monaco" },
    { code: "MN", label: "Mongolia" },
    { code: "ME", label: "Montenegro" },
    { code: "MA", label: "Morocco" },
    { code: "MZ", label: "Mozambique" },
    { code: "MM", label: "Myanmar" },
    { code: "NA", label: "Namibia" },
    { code: "NR", label: "Nauru" },
    { code: "NP", label: "Nepal" },
    { code: "NL", label: "Netherlands" },
    { code: "NZ", label: "New Zealand" },
    { code: "NI", label: "Nicaragua" },
    { code: "NE", label: "Niger" },
    { code: "NG", label: "Nigeria" },
    { code: "MK", label: "North Macedonia" },
    { code: "NO", label: "Norway" },
    { code: "OM", label: "Oman" },
    { code: "PK", label: "Pakistan" },
    { code: "PW", label: "Palau" },
    { code: "PS", label: "Palestine" },
    { code: "PA", label: "Panama" },
    { code: "PG", label: "Papua New Guinea" },
    { code: "PY", label: "Paraguay" },
    { code: "PE", label: "Peru" },
    { code: "PH", label: "Philippines" },
    { code: "PL", label: "Poland" },
    { code: "PT", label: "Portugal" },
    { code: "QA", label: "Qatar" },
    { code: "RO", label: "Romania" },
    { code: "RU", label: "Russia" },
    { code: "RW", label: "Rwanda" },
    { code: "KN", label: "Saint Kitts and Nevis" },
    { code: "LC", label: "Saint Lucia" },
    { code: "VC", label: "Saint Vincent and the Grenadines" },
    { code: "WS", label: "Samoa" },
    { code: "SM", label: "San Marino" },
    { code: "ST", label: "São Tomé and Príncipe" },
    { code: "SA", label: "Saudi Arabia" },
    { code: "SN", label: "Senegal" },
    { code: "RS", label: "Serbia" },
    { code: "SC", label: "Seychelles" },
    { code: "SL", label: "Sierra Leone" },
    { code: "SG", label: "Singapore" },
    { code: "SK", label: "Slovakia" },
    { code: "SI", label: "Slovenia" },
    { code: "SB", label: "Solomon Islands" },
    { code: "SO", label: "Somalia" },
    { code: "ZA", label: "South Africa" },
    { code: "SS", label: "South Sudan" },
    { code: "ES", label: "Spain" },
    { code: "LK", label: "Sri Lanka" },
    { code: "SD", label: "Sudan" },
    { code: "SR", label: "Suriname" },
    { code: "SE", label: "Sweden" },
    { code: "CH", label: "Switzerland" },
    { code: "SY", label: "Syria" },
    { code: "TW", label: "Taiwan" },
    { code: "TJ", label: "Tajikistan" },
    { code: "TZ", label: "Tanzania" },
    { code: "TH", label: "Thailand" },
    { code: "TL", label: "Timor-Leste" },
    { code: "TG", label: "Togo" },
    { code: "TO", label: "Tonga" },
    { code: "TT", label: "Trinidad and Tobago" },
    { code: "TN", label: "Tunisia" },
    { code: "TR", label: "Turkey" },
    { code: "TM", label: "Turkmenistan" },
    { code: "TV", label: "Tuvalu" },
    { code: "UG", label: "Uganda" },
    { code: "UA", label: "Ukraine" },
    { code: "AE", label: "United Arab Emirates" },
    { code: "GB", label: "United Kingdom" },
    { code: "UY", label: "Uruguay" },
    { code: "UZ", label: "Uzbekistan" },
    { code: "VU", label: "Vanuatu" },
    { code: "VA", label: "Vatican City" },
    { code: "VE", label: "Venezuela" },
    { code: "VN", label: "Vietnam" },
    { code: "YE", label: "Yemen" },
    { code: "ZM", label: "Zambia" },
    { code: "ZW", label: "Zimbabwe" },
];

const US_STATES = [
    { value: "AL", label: "Alabama" },
    { value: "AK", label: "Alaska" },
    { value: "AZ", label: "Arizona" },
    { value: "AR", label: "Arkansas" },
    { value: "CA", label: "California" },
    { value: "CO", label: "Colorado" },
    { value: "CT", label: "Connecticut" },
    { value: "DE", label: "Delaware" },
    { value: "FL", label: "Florida" },
    { value: "GA", label: "Georgia" },
    { value: "HI", label: "Hawaii" },
    { value: "ID", label: "Idaho" },
    { value: "IL", label: "Illinois" },
    { value: "IN", label: "Indiana" },
    { value: "IA", label: "Iowa" },
    { value: "KS", label: "Kansas" },
    { value: "KY", label: "Kentucky" },
    { value: "LA", label: "Louisiana" },
    { value: "ME", label: "Maine" },
    { value: "MD", label: "Maryland" },
    { value: "MA", label: "Massachusetts" },
    { value: "MI", label: "Michigan" },
    { value: "MN", label: "Minnesota" },
    { value: "MS", label: "Mississippi" },
    { value: "MO", label: "Missouri" },
    { value: "MT", label: "Montana" },
    { value: "NE", label: "Nebraska" },
    { value: "NV", label: "Nevada" },
    { value: "NH", label: "New Hampshire" },
    { value: "NJ", label: "New Jersey" },
    { value: "NM", label: "New Mexico" },
    { value: "NY", label: "New York" },
    { value: "NC", label: "North Carolina" },
    { value: "ND", label: "North Dakota" },
    { value: "OH", label: "Ohio" },
    { value: "OK", label: "Oklahoma" },
    { value: "OR", label: "Oregon" },
    { value: "PA", label: "Pennsylvania" },
    { value: "RI", label: "Rhode Island" },
    { value: "SC", label: "South Carolina" },
    { value: "SD", label: "South Dakota" },
    { value: "TN", label: "Tennessee" },
    { value: "TX", label: "Texas" },
    { value: "UT", label: "Utah" },
    { value: "VT", label: "Vermont" },
    { value: "VA", label: "Virginia" },
    { value: "WA", label: "Washington" },
    { value: "WV", label: "West Virginia" },
    { value: "WI", label: "Wisconsin" },
    { value: "WY", label: "Wyoming" },
];

// Debounce utility function
function debounce<T extends (...args: any[]) => any>(func: T, wait: number): T {
    let timeout: NodeJS.Timeout;
    return ((...args: any[]) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func(...args), wait);
    }) as T;
}

const initialValues = {
    // Contact Information
    contactEmail: "",
    contactFirstName: "",
    contactLastName: "",
    contactPhone: "",
    contactEveningPhone: "",
    
    // Company Information
    companyDesiredName: "",
    companyAlternativeName: "",
    companyBusinessCategory: "",
    companyBusinessDescription: "",
    
    // Business Address
    businessAddressCountry: DEFAULT_COUNTRY,
    businessAddressAddress1: "",
    businessAddressAddress2: "",
    businessAddressCity: "",
    businessAddressState: DEFAULT_STATE,
    businessAddressZip: "",
    
    // Registered Agent
    registeredAgentIsCorpnetAgent: false,
    registeredAgentFirstName: "",
    registeredAgentLastName: "",
    registeredAgentAddress1: "",
    registeredAgentAddress2: "",
    registeredAgentCity: "",
    registeredAgentState: DEFAULT_STATE,
    registeredAgentZip: "",
    registeredAgentCountry: DEFAULT_COUNTRY,
    
    // Officers (for Corporations)
    officersPresidentFirstName: "",
    officersPresidentLastName: "",
    officersVicePresidentFirstName: "",
    officersVicePresidentLastName: "",
    officersSecretaryFirstName: "",
    officersSecretaryLastName: "",
    officersTreasurerFirstName: "",
    officersTreasurerLastName: "",
    
    // LLC Specific
    llcOnlyMembers: [{
        firstName: "",
        lastName: "",
        country: DEFAULT_COUNTRY,
        address1: "",
        address2: "",
        city: "",
        state: DEFAULT_STATE,
        zip: "",
        percentageOwnership: "",
        itemContributed: "",
        itemContributerMarketValue: "",
        isMemberManaged: true,
    }],
    
    // LLC Organizer
    llcOnlyOrganizer: "",
    llcOnlyOrganizerFirstName: "",
    llcOnlyOrganizerLastName: "",
    llcOnlyOrganizerCountry: DEFAULT_COUNTRY,
    llcOnlyOrganizerAddress1: "",
    llcOnlyOrganizerAddress2: "",
    llcOnlyOrganizerCity: "",
    llcOnlyOrganizerState: DEFAULT_STATE,
    llcOnlyOrganizerZip: "",
    
    // Nonprofit Incorporator
    nonprofitIncorporatorFirstName: "",
    nonprofitIncorporatorLastName: "",
    nonprofitIncorporatorCountry: DEFAULT_COUNTRY,
    nonprofitIncorporatorAddress1: "",
    nonprofitIncorporatorAddress2: "",
    nonprofitIncorporatorCity: "",
    nonprofitIncorporatorState: DEFAULT_STATE,
    nonprofitIncorporatorZip: "",
    
    // Corporation Specific
    corporationsOnlyAuthorizedShares: "",
    corporationOnlyParValue: "",
    corporationOnlyDirector1InfoCountry: DEFAULT_COUNTRY,
    corporationOnlyDirector1InfoAddress1: "",
    corporationOnlyDirector1InfoAddress2: "",
    corporationOnlyDirector1InfoCity: "",
    corporationOnlyDirector1InfoState: DEFAULT_STATE,
    corporationOnlyDirector1InfoZip: "",
    
    // Responsible Party
    responsibleParty: "",
    responsiblePartyFirstName: "",
    responsiblePartyMiddleName: "",
    responsiblePartyLastName: "",
    responsiblePartyEmail: "",
    responsiblePartyStatus: "No",
    responsiblePartySSN: ""
};

// Helper function to create conditional validation schema based on business structure type
const createValidationSchema = (businessStructureType: string) => Yup.object({
    // Contact Information - Always required
    contactEmail: Yup.string().email("Invalid email").required("Required"),
    contactFirstName: Yup.string().required("Required"),
    contactLastName: Yup.string().required("Required"),
    contactPhone: Yup.string().required("Required"),
    contactEveningPhone: Yup.string(), // Optional
    
    // Company Information - Always required
    companyDesiredName: Yup.string().required("Required"),
    companyAlternativeName: Yup.string(), // Optional
    companyBusinessCategory: Yup.string().required("Required"),
    companyBusinessDescription: Yup.string().required("Required"),
    
    // Business Address - Always required
    businessAddressCountry: Yup.string().required("Required"),
    businessAddressAddress1: Yup.string().required("Required"),
    businessAddressAddress2: Yup.string(), // Optional
    businessAddressCity: Yup.string().required("Required"),
    businessAddressState: Yup.string().required("Required"),
    businessAddressZip: Yup.string()
        .required("Zip code is required")
        .when('businessAddressCountry', {
            is: (country: string) => country === DEFAULT_COUNTRY,
            then: (schema) => schema.matches(/^\d{5}$/, "Zip code must be exactly 5 digits"),
            otherwise: (schema) => schema
        }),
    
    // Registered Agent - Conditional validation
    registeredAgentIsCorpnetAgent: Yup.boolean(),
    registeredAgentFirstName: Yup.string().when('registeredAgentIsCorpnetAgent', (isCorpnet, schema) => isCorpnet ? schema : schema.required('Required')),
    registeredAgentLastName: Yup.string().when('registeredAgentIsCorpnetAgent', (isCorpnet, schema) => isCorpnet ? schema : schema.required('Required')),
    registeredAgentAddress1: Yup.string().when('registeredAgentIsCorpnetAgent', (isCorpnet, schema) => isCorpnet ? schema : schema.required('Required')),
    registeredAgentAddress2: Yup.string(), // Optional
    registeredAgentCity: Yup.string().when('registeredAgentIsCorpnetAgent', (isCorpnet, schema) => isCorpnet ? schema : schema.required('Required')),
    registeredAgentState: Yup.string().when('registeredAgentIsCorpnetAgent', (isCorpnet, schema) => isCorpnet ? schema : schema.required('Required')),
    registeredAgentZip: Yup.string().when(['registeredAgentIsCorpnetAgent', 'registeredAgentCountry'], ([isCorpnet, country], schema) => {
        if (isCorpnet) {
            return schema;
        }
        let updatedSchema = schema.required('Zip code is required');
        if (country === DEFAULT_COUNTRY) {
            updatedSchema = updatedSchema.matches(/^\d{5}$/, "Zip code must be exactly 5 digits");
        }
        return updatedSchema;
    }),
    registeredAgentCountry: Yup.string().when('registeredAgentIsCorpnetAgent', (isCorpnet, schema) => isCorpnet ? schema : schema.required('Required')),
    
    // Officers - Required for Corporations
    officersPresidentFirstName: Yup.string().when([], {
        is: () => businessStructureType === "C-Corporation" || businessStructureType === "S-Corporation" || businessStructureType === "Professional Corporation",
        then: (schema) => schema.required("Required for Corporations"),
        otherwise: (schema) => schema
    }),
    officersPresidentLastName: Yup.string().when([], {
        is: () => businessStructureType === "C-Corporation" || businessStructureType === "S-Corporation" || businessStructureType === "Professional Corporation",
        then: (schema) => schema.required("Required for Corporations"),
        otherwise: (schema) => schema
    }),
    officersVicePresidentFirstName: Yup.string(), // Optional
    officersVicePresidentLastName: Yup.string(), // Optional
    officersSecretaryFirstName: Yup.string(), // Optional
    officersSecretaryLastName: Yup.string(), // Optional
    officersTreasurerFirstName: Yup.string(), // Optional
    officersTreasurerLastName: Yup.string(), // Optional
    
    // LLC Specific - Required for LLC
    llcOnlyMembers: Yup.array().when([], {
        is: () => businessStructureType === "LLC",
        then: (schema) => schema
            .of(
                Yup.object({
                    firstName: Yup.string().required("First name is required"),
                    lastName: Yup.string().required("Last name is required"),
                    country: Yup.string().required("Country is required"),
                    address1: Yup.string().required("Address is required"),
                    address2: Yup.string(), // Optional
                    city: Yup.string().required("City is required"),
                    state: Yup.string().required("State is required"),
                    zip: Yup.string()
                        .required("Zip code is required")
                        .when('country', {
                            is: (country: string) => country === DEFAULT_COUNTRY,
                            then: (schema) => schema.matches(/^\d{5}$/, "Zip code must be exactly 5 digits"),
                            otherwise: (schema) => schema
                        }),
                    percentageOwnership: Yup.string()
                        .required("Percentage ownership is required")
                        .test('is-number', 'Must be a valid number', value => !isNaN(parseFloat(value || '')))
                        .test('min-value', 'Percentage must be greater than 0', value => parseFloat(value || '0') > 0)
                        .test('max-value', 'Percentage cannot exceed 100', value => parseFloat(value || '0') <= 100),
                    itemContributed: Yup.string(), // Optional
                    itemContributerMarketValue: Yup.number().min(0), // Optional
                    isMemberManaged: Yup.boolean().required("Member management type is required"),
                })
            )
            .min(1, "At least one member is required for LLC")
            .test('total-ownership', 'Total ownership percentage must equal 100%', function(members) {
                if (!members || members.length === 0) return true;
                const total = members.reduce((sum, member) => {
                    const percentage = parseFloat(member.percentageOwnership) || 0;
                    return sum + percentage;
                }, 0);
                return Math.abs(total - 100) < 0.01; // Allow small floating point differences
            }),
        otherwise: (schema) => schema
    }),
    
    // LLC Organizer - Required for LLC
    llcOnlyOrganizer: Yup.string(), // Optional
    llcOnlyOrganizerFirstName: Yup.string().when([], {
        is: () => businessStructureType === "LLC",
        then: (schema) => schema.required("Required for LLC"),
        otherwise: (schema) => schema
    }),
    llcOnlyOrganizerLastName: Yup.string().when([], {
        is: () => businessStructureType === "LLC",
        then: (schema) => schema.required("Required for LLC"),
        otherwise: (schema) => schema
    }),
    llcOnlyOrganizerCountry: Yup.string().when([], {
        is: () => businessStructureType === "LLC",
        then: (schema) => schema.required("Required for LLC"),
        otherwise: (schema) => schema
    }),
    llcOnlyOrganizerAddress1: Yup.string().when([], {
        is: () => businessStructureType === "LLC",
        then: (schema) => schema.required("Required for LLC"),
        otherwise: (schema) => schema
    }),
    llcOnlyOrganizerAddress2: Yup.string(), // Optional
    llcOnlyOrganizerCity: Yup.string().when([], {
        is: () => businessStructureType === "LLC",
        then: (schema) => schema.required("Required for LLC"),
        otherwise: (schema) => schema
    }),
    llcOnlyOrganizerState: Yup.string().when([], {
        is: () => businessStructureType === "LLC",
        then: (schema) => schema.required("Required for LLC"),
        otherwise: (schema) => schema
    }),
    llcOnlyOrganizerZip: Yup.string().when([], {
        is: () => businessStructureType === "LLC",
        then: (schema) => schema
            .required("Zip code is required")
            .when('llcOnlyOrganizerCountry', {
                is: (country: string) => country === DEFAULT_COUNTRY,
                then: (countrySchema) => countrySchema.matches(/^\d{5}$/, "Zip code must be exactly 5 digits"),
                otherwise: (countrySchema) => countrySchema
            }),
        otherwise: (schema) => schema
    }),
    
    // Nonprofit Incorporator - Required for Non-Profit Corporation
    nonprofitIncorporatorFirstName: Yup.string().when([], {
        is: () => businessStructureType === "Non-Profit Corporation",
        then: (schema) => schema.required("Required for Non-Profit Corporation"),
        otherwise: (schema) => schema
    }),
    nonprofitIncorporatorLastName: Yup.string().when([], {
        is: () => businessStructureType === "Non-Profit Corporation",
        then: (schema) => schema.required("Required for Non-Profit Corporation"),
        otherwise: (schema) => schema
    }),
    nonprofitIncorporatorCountry: Yup.string().when([], {
        is: () => businessStructureType === "Non-Profit Corporation",
        then: (schema) => schema.required("Required for Non-Profit Corporation"),
        otherwise: (schema) => schema
    }),
    nonprofitIncorporatorAddress1: Yup.string().when([], {
        is: () => businessStructureType === "Non-Profit Corporation",
        then: (schema) => schema.required("Required for Non-Profit Corporation"),
        otherwise: (schema) => schema
    }),
    nonprofitIncorporatorAddress2: Yup.string(), // Optional
    nonprofitIncorporatorCity: Yup.string().when([], {
        is: () => businessStructureType === "Non-Profit Corporation",
        then: (schema) => schema.required("Required for Non-Profit Corporation"),
        otherwise: (schema) => schema
    }),
    nonprofitIncorporatorState: Yup.string().when([], {
        is: () => businessStructureType === "Non-Profit Corporation",
        then: (schema) => schema.required("Required for Non-Profit Corporation"),
        otherwise: (schema) => schema
    }),
    nonprofitIncorporatorZip: Yup.string().when([], {
        is: () => businessStructureType === "Non-Profit Corporation",
        then: (schema) => schema
            .required("Zip code is required")
            .when('nonprofitIncorporatorCountry', {
                is: (country: string) => country === DEFAULT_COUNTRY,
                then: (countrySchema) => countrySchema.matches(/^\d{5}$/, "Zip code must be exactly 5 digits"),
                otherwise: (countrySchema) => countrySchema
            }),
        otherwise: (schema) => schema
    }),
    
    // Corporation Specific - Required for Corporations
    corporationsOnlyAuthorizedShares: Yup.number().when([], {
        is: () => businessStructureType === "C-Corporation" || businessStructureType === "S-Corporation" || businessStructureType === "Professional Corporation",
        then: (schema) => schema.required("Required for Corporations").min(1),
        otherwise: (schema) => schema
    }),
    corporationOnlyParValue: Yup.number().min(0), // Optional
    corporationOnlyDirector1InfoCountry: Yup.string().when([], {
        is: () => businessStructureType === "C-Corporation" || businessStructureType === "S-Corporation" || businessStructureType === "Professional Corporation",
        then: (schema) => schema.required("Required for Corporations"),
        otherwise: (schema) => schema
    }),
    corporationOnlyDirector1InfoAddress1: Yup.string().when([], {
        is: () => businessStructureType === "C-Corporation" || businessStructureType === "S-Corporation" || businessStructureType === "Professional Corporation",
        then: (schema) => schema.required("Required for Corporations"),
        otherwise: (schema) => schema
    }),
    corporationOnlyDirector1InfoAddress2: Yup.string(), // Optional
    corporationOnlyDirector1InfoCity: Yup.string().when([], {
        is: () => businessStructureType === "C-Corporation" || businessStructureType === "S-Corporation" || businessStructureType === "Professional Corporation",
        then: (schema) => schema.required("Required for Corporations"),
        otherwise: (schema) => schema
    }),
    corporationOnlyDirector1InfoState: Yup.string().when([], {
        is: () => businessStructureType === "C-Corporation" || businessStructureType === "S-Corporation" || businessStructureType === "Professional Corporation",
        then: (schema) => schema.required("Required for Corporations"),
        otherwise: (schema) => schema
    }),
    corporationOnlyDirector1InfoZip: Yup.string().when([], {
        is: () => businessStructureType === "C-Corporation" || businessStructureType === "S-Corporation" || businessStructureType === "Professional Corporation",
        then: (schema) => schema
            .required("Zip code is required")
            .when('corporationOnlyDirector1InfoCountry', {
                is: (country: string) => country === DEFAULT_COUNTRY,
                then: (countrySchema) => countrySchema.matches(/^\d{5}$/, "Zip code must be exactly 5 digits"),
                otherwise: (countrySchema) => countrySchema
            }),
        otherwise: (schema) => schema
    }),
    
    // Responsible Party - Always required
    responsibleParty: Yup.string().required("Required"),
    responsiblePartyFirstName: Yup.string().required("Required"),
    responsiblePartyMiddleName: Yup.string(), // Optional
    responsiblePartyLastName: Yup.string().required("Required"),
    responsiblePartyEmail: Yup.string().when('responsiblePartySSN', {
        is: (ssn: string) => ssn && ssn.length > 0,
        then: (schema) => schema.email("Invalid email").required("Required if SSN provided"),
        otherwise: (schema) => schema.email("Invalid email")
    }),
    responsiblePartyStatus: Yup.string().required("Required"),
    responsiblePartySSN: Yup.string().when('responsiblePartyStatus', {
        is: "Yes",
        then: (schema) => schema.required("Required").matches(/^\d{9}$/, "SSN must be 9 digits"),
        otherwise: (schema) => schema
    })
});

interface CFFormProps {
    productIds: string[];
    businessStructureType: string;
    businessStateInitial: string;
    packageId: string;
    orderTotalPrice: string;
    onClose?: () => void;
}

export const CFForm: React.FC<CFFormProps> = ({ productIds, businessStructureType, businessStateInitial, packageId, orderTotalPrice, onClose }) => {
    // Only enable AI bot in development mode
    const isDevMode = process.env.NODE_ENV === 'development';
    
    const [alertMsg, setAlertMsg] = useState<{ open: boolean; type: "success" | "error"; content: string }>({ open: false, type: "success", content: "" });
    const [orderPlaced, setOrderPlaced] = useState<string | null>(null);
    const [checkoutDisclaimer, setCheckoutDisclaimer] = useState<CheckoutDisclaimer | null>(null);
    const [disclaimerAccepted, setDisclaimerAccepted] = useState(false);
    const [showBotChat, setShowBotChat] = useState<boolean>(false);
    const [chatMessage, setChatMessage] = useState<string>("");
    const [isProcessingAI, setIsProcessingAI] = useState<boolean>(false);
    const [isLoadingSavedForm, setIsLoadingSavedForm] = useState<boolean>(true);
    const [savedFormData, setSavedFormData] = useState<any>(null);
    const [messages, setMessages] = useState<Array<{id: string, text: string, sender: 'user' | 'bot', timestamp: Date}>>([
        {
            id: '1',
            text: "Hi! I'm your AI assistant for company formation. Just tell me about your company in your own words - like your name, contact info, business details, address, etc. I'll automatically fill out the form for you! 🤖",
            sender: 'bot',
            timestamp: new Date()
        }
    ]);
    const messagesEndRef = React.useRef<HTMLDivElement>(null);
    const formik = useFormik({
        initialValues,
        validationSchema: createValidationSchema(businessStructureType),
        onSubmit: async (values, { setSubmitting, resetForm }) => {
            setAlertMsg({ open: false, type: "success", content: "" });
            let pcid = "";
            const payload = {
                orderBody: {
                    partnerOrder: {
                        // Basic order information
                        apiUserPid: "1001",
                        pcid,
                        businessStructureType,
                        businessStateInitial,
                        orderTotalPrice: parseFloat(orderTotalPrice),
                        packageId,
                        products: productIds.map(pid => ({ productId: pid, quantity: "1" })),
                        
                        // Contact information
                        contact: {
                            contactEmail: values.contactEmail,
                            contactFirstName: values.contactFirstName,
                            contactLastName: values.contactLastName,
                            contactPhone: values.contactPhone,
                            contactEveningPhone: values.contactEveningPhone,
                        },
                        
                        // Company information
                        companyInfo: {
                            companyDesiredName: values.companyDesiredName,
                            companyAlternativeName: values.companyAlternativeName,
                            companyBusinessCategory: values.companyBusinessCategory,
                            companyBusinessDescription: values.companyBusinessDescription,
                        },
                        
                        // Business address
                        businessAddress: {
                            businessAddressCountry: values.businessAddressCountry,
                            businessAddressAddress1: values.businessAddressAddress1,
                            businessAddressAddress2: values.businessAddressAddress2,
                            businessAddressCity: values.businessAddressCity,
                            businessAddressState: values.businessAddressState,
                            businessAddressZip: values.businessAddressZip,
                        },
                        
                        // Registered agent - only include address fields if not CorpNet agent
                        registerAgent: {
                            registeredAgentIsCorpnetAgent: values.registeredAgentIsCorpnetAgent,
                            ...(!values.registeredAgentIsCorpnetAgent && {
                                registeredAgentFirstName: values.registeredAgentFirstName,
                                registeredAgentLastName: values.registeredAgentLastName,
                                registeredAgentAddress1: values.registeredAgentAddress1,
                                registeredAgentAddress2: values.registeredAgentAddress2,
                                registeredAgentCity: values.registeredAgentCity,
                                registeredAgentState: values.registeredAgentState,
                                registeredAgentZip: values.registeredAgentZip,
                                registeredAgentCountry: values.registeredAgentCountry,
                            })
                        },
                        
                        // Officers - only include for Corporations
                        ...(businessStructureType === "C-Corporation" || businessStructureType === "S-Corporation" || businessStructureType === "Professional Corporation" ? {
                            officer: {
                                officersPresidentFirstName: values.officersPresidentFirstName || "",
                                officersPresidentLastName: values.officersPresidentLastName || "",
                                officersVicePresidentFirstName: values.officersVicePresidentFirstName || "",
                                officersVicePresidentLastName: values.officersVicePresidentLastName || "",
                                officersSecretaryFirstName: values.officersSecretaryFirstName || "",
                                officersSecretaryLastName: values.officersSecretaryLastName || "",
                                officersTreasurerFirstName: values.officersTreasurerFirstName || "",
                                officersTreasurerLastName: values.officersTreasurerLastName || "",
                            }
                        } : {}),
                        
                        // LLC specific fields - only include for LLC
                        ...(businessStructureType === "LLC" ? {
                            llcOnly: values.llcOnlyMembers?.map((member: any) => ({
                                llcOnlyIsMemberManaged: member.isMemberManaged,
                                llcOnlyMember1InfoFirstName: member.firstName,
                                llcOnlyMember1InfoLastName: member.lastName,
                                llcOnlyMember1InfoCountry: member.country,
                                llcOnlyMember1InfoAddress1: member.address1,
                                llcOnlyMember1InfoAddress2: member.address2 || "",
                                llcOnlyMember1InfoCity: member.city,
                                llcOnlyMember1InfoState: member.state,
                                llcOnlyMember1InfoZip: member.zip,
                                llcOnlyMember1InfoPercentageOwnership: parseFloat(member.percentageOwnership) || 0,
                                llcOnlyMember1InfoItemContributed: member.itemContributed || "",
                                llcOnlyMember1InfoItemContributerMarketValue: parseFloat(member.itemContributerMarketValue) || 0,
                            })) || []
                        } : {}),
                        
                        // LLC organizer - only include for LLC
                        ...(businessStructureType === "LLC" ? {
                            llcOrganizer: {
                                llcOnlyOrganizer: values.llcOnlyOrganizer || "",
                                llcOnlyOrganizerFirstName: values.llcOnlyOrganizerFirstName || "",
                                llcOnlyOrganizerLastName: values.llcOnlyOrganizerLastName || "",
                                llcOnlyOrganizerCountry: values.llcOnlyOrganizerCountry || "",
                                llcOnlyOrganizerAddress1: values.llcOnlyOrganizerAddress1 || "",
                                llcOnlyOrganizerAddress2: values.llcOnlyOrganizerAddress2 || "",
                                llcOnlyOrganizerCity: values.llcOnlyOrganizerCity || "",
                                llcOnlyOrganizerState: values.llcOnlyOrganizerState || "",
                                llcOnlyOrganizerZip: values.llcOnlyOrganizerZip || "",
                            }
                        } : {}),
                        
                        // Nonprofit incorporator - only include for Non-Profit Corporation
                        ...(businessStructureType === "Non-Profit Corporation" ? {
                            nonprofitIncorporator: {
                                nonprofitIncorporatorFirstName: values.nonprofitIncorporatorFirstName || "",
                                nonprofitIncorporatorLastName: values.nonprofitIncorporatorLastName || "",
                                nonprofitIncorporatorCountry: values.nonprofitIncorporatorCountry || "",
                                nonprofitIncorporatorAddress1: values.nonprofitIncorporatorAddress1 || "",
                                nonprofitIncorporatorAddress2: values.nonprofitIncorporatorAddress2 || "",
                                nonprofitIncorporatorCity: values.nonprofitIncorporatorCity || "",
                                nonprofitIncorporatorState: values.nonprofitIncorporatorState || "",
                                nonprofitIncorporatorZip: values.nonprofitIncorporatorZip || "",
                            }
                        } : {}),
                        
                        // Corporation specific fields - only include for Corporations
                        ...(businessStructureType === "C-Corporation" || businessStructureType === "S-Corporation" || businessStructureType === "Professional Corporation" ? {
                            corporationsOnly: {
                                corporationsOnlyAuthorizedShares: values.corporationsOnlyAuthorizedShares || 0,
                                corporationOnlyParValue: values.corporationOnlyParValue || 0,
                                corporationOnlyDirector1InfoCountry: values.corporationOnlyDirector1InfoCountry || "",
                                corporationOnlyDirector1InfoAddress1: values.corporationOnlyDirector1InfoAddress1 || "",
                                corporationOnlyDirector1InfoAddress2: values.corporationOnlyDirector1InfoAddress2 || "",
                                corporationOnlyDirector1InfoCity: values.corporationOnlyDirector1InfoCity || "",
                                corporationOnlyDirector1InfoState: values.corporationOnlyDirector1InfoState || "",
                                corporationOnlyDirector1InfoZip: values.corporationOnlyDirector1InfoZip || "",
                            }
                        } : {}),
                        
                        // Responsible party
                        responsibleParty: {
                            responsibleParty: values.responsibleParty,
                            responsiblePartyFirstName: values.responsiblePartyFirstName,
                            responsiblePartyMiddleName: values.responsiblePartyMiddleName,
                            responsiblePartyLastName: values.responsiblePartyLastName,
                            responsiblePartyEmail: values.responsiblePartyEmail,
                            responsiblePartyStatus: values.responsiblePartyStatus,
                            responsiblePartySSN: values.responsiblePartySSN,
                        }
                    },
                }
            };
            try {
                let returnUrl = "";
                if (typeof window !== "undefined") {
                    const currentUrl = new URL(window.location.href);
                    currentUrl.searchParams.delete("payment");
                    currentUrl.searchParams.delete("session_id");
                    returnUrl = `${currentUrl.origin}${currentUrl.pathname}${currentUrl.search}`;
                }
                if (!returnUrl) {
                    returnUrl = typeof window !== "undefined" ? window.location.origin : "/";
                }
                
                // Extract package and product names for snapshot (optional - gracefully handle if data unavailable)
                let selectedItems: any = null;
                
                try {
                    selectedItems = {
                        package: { id: packageId || "", name: "", price: 0 },
                        products: []
                    };
                    
                    // Get package name and price
                    if ((window as any).CFPlansPackageData && packageId) {
                        const pkg = (window as any).CFPlansPackageData.find((p: any) => p.id === packageId);
                        if (pkg) {
                            selectedItems.package.name = pkg.name || "";
                            selectedItems.package.price = Number(pkg.price) || 0;
                        }
                    }
                    // Fallback to packageName state if available
                    if (!selectedItems.package.name && packageName) {
                        selectedItems.package.name = packageName;
                    }
                    
                    // Get product names and prices
                    if (productIds && productIds.length > 0 && (window as any).CFPlansPackageData) {
                        const allPackages = (window as any).CFPlansPackageData || [];
                        productIds.forEach((productId: string) => {
                            // Search through all packages to find the product
                            for (const pkg of allPackages) {
                                if (pkg.productOptions) {
                                    const product = pkg.productOptions.find((opt: any) => opt.productId === productId);
                                    if (product) {
                                        selectedItems.products.push({
                                            id: productId,
                                            name: product.productName || "",
                                            price: Number(product.price) || 0
                                        });
                                        break;
                                    }
                                }
                            }
                        });
                    }
                    
                    // Only include selectedItems if we have at least package ID
                    if (!selectedItems.package.id) {
                        selectedItems = null;
                    }
                } catch (error) {
                    console.warn("Error extracting selected items snapshot:", error);
                    selectedItems = null; // Gracefully fail - order can still proceed
                }
                
                // Step 1: Create Stripe Checkout Session
                setAlertMsg({ open: false, type: "success", content: "" });
                setSubmitting(true);
                
                const checkoutPayload: any = {
                    orderBody: payload.orderBody,
                    totalPrice: Number(orderTotalPrice),
                    successUrl: returnUrl,
                    cancelUrl: returnUrl
                };
                
                // Only include selectedItems if we successfully extracted them
                if (selectedItems) {
                    checkoutPayload.selectedItems = selectedItems;
                }

                if (checkoutDisclaimer) {
                    checkoutPayload.disclaimer_version_id = checkoutDisclaimer.id;
                }
                
                const checkoutResp = await axios.post(
                    "/companyFormation/createCheckout",
                    checkoutPayload,
                    { withCredentials: true }
                );
                
                if (checkoutResp && checkoutResp.status === 'checkout_stripe' && checkoutResp.checkout_url) {
                    // Redirect to Stripe Checkout
                    window.location.href = checkoutResp.checkout_url;
                    // Note: The form will remain open until payment is completed
                    // The success callback will handle order creation
                } else {
                    setAlertMsg({ 
                        open: true, 
                        type: 'error', 
                        content: checkoutResp.error || 'Failed to create checkout session' 
                    });
                    setSubmitting(false);
                }
            } catch (error: any) {
                console.error("Error creating checkout session:", error);
                
                // Handle network/axios errors
                let errorMessage = 'Failed to create checkout session';
                if (error?.response?.data) {
                    const responseData = error.response.data;
                    if (responseData.error) {
                        errorMessage = responseData.error;
                    } else if (responseData.message) {
                        errorMessage = responseData.message;
                    }
                } else if (error?.message) {
                    errorMessage = error.message;
                }
                
                setAlertMsg({ open: true, type: 'error', content: errorMessage });
                setSubmitting(false);
            }
        },
    });

    const handleCountryChange = (countryField: string, stateField: string, value: string) => {
        formik.setFieldValue(countryField, value);
        formik.setFieldValue(stateField, value === DEFAULT_COUNTRY ? DEFAULT_STATE : "");
    };

    useEffect(() => {
        fetchCheckoutDisclaimer().then(setCheckoutDisclaimer);
    }, []);

    // When productIds prop changes, update Formik's products field
    React.useEffect(() => {
        if (productIds && productIds.length > 0) {
            formik.setFieldValue(
                "products",
                productIds.map(pid => ({ productId: pid, quantity: "1" }))
            );
        }
    }, [productIds]);

    // Find package name and price from props if available
    const [packageName, setPackageName] = useState<string>("");
    React.useEffect(() => {
        if ((window as any).CFPlansPackageData && packageId) {
            const pkg = (window as any).CFPlansPackageData.find((p: any) => p.id === packageId);
            if (pkg) {
                setPackageName(pkg.name);
            }
        } else {
            setPackageName("");
        }
    }, [packageId]);

    // Function to call AI bot API and auto-fill form
    const processWithAI = async (updatedMessages: Array<{id: string, text: string, sender: 'user' | 'bot', timestamp: Date}>) => {
        // Only allow AI processing in dev mode
        if (!isDevMode) {
            console.warn('AI bot is only available in development mode');
            return;
        }
        
        if (isProcessingAI) return; // Prevent multiple simultaneous calls
        
        setIsProcessingAI(true);
        
        try {
            const botResponse = {
                id: Date.now().toString() + '_bot',
                text: "Let me process that information and fill out your form automatically... ⚡",
                sender: 'bot' as const,
                timestamp: new Date()
            };
            setMessages(prev => [...prev, botResponse]);

            const response = await axios.post('/companyFormation/corpnet_form_ai_bot', {
                chatHistory: updatedMessages,
                emptyFormStructure: initialValues
            }, { withCredentials: true });

            // Handle response data (could be in response.data or response directly)
            const actualData = response.data || response;

            if (actualData && actualData.filledForm && typeof actualData.filledForm === 'object' && actualData.filledForm !== null) {
                // Auto-fill the form using Formik
                const filledData = actualData.filledForm;
                
                Object.keys(filledData).forEach(key => {
                    if (filledData[key] !== "" && filledData[key] !== null && filledData[key] !== undefined) {
                        formik.setFieldValue(key, filledData[key]);
                    }
                });

                const successResponse = {
                    id: Date.now().toString() + '_bot_success',
                    text: "Perfect! I've automatically filled out your form based on the information you provided. Please review and make any necessary adjustments! ✅",
                    sender: 'bot' as const,
                    timestamp: new Date()
                };
                setMessages(prev => [...prev, successResponse]);
            } else {
                // Fallback: Check if it's a successful response but with different structure
                if (actualData?.status === 'success' && actualData?.filledForm) {
                    const filledData = actualData.filledForm;
                    
                    Object.keys(filledData).forEach(key => {
                        if (filledData[key] !== "" && filledData[key] !== null && filledData[key] !== undefined) {
                            formik.setFieldValue(key, filledData[key]);
                        }
                    });
                    
                    const successResponse = {
                        id: Date.now().toString() + '_bot_success',
                        text: "Perfect! I've automatically filled out your form based on the information you provided. Please review and make any necessary adjustments! ✅",
                        sender: 'bot' as const,
                        timestamp: new Date()
                    };
                    setMessages(prev => [...prev, successResponse]);
                } else {
                    throw new Error('Invalid response from AI service');
                }
            }
        } catch (error: any) {
            console.error('AI processing error:', error);
            
            let errorMessage = "Sorry, I encountered an error processing your information. Please try again or fill out the form manually.";
            
            if (error?.response?.data?.error) {
                errorMessage = `AI Error: ${error.response.data.error}`;
            } else if (error?.message) {
                errorMessage = `Error: ${error.message}`;
            }
            
            const errorResponse = {
                id: Date.now().toString() + '_bot_error',
                text: errorMessage,
                sender: 'bot' as const,
                timestamp: new Date()
            };
            setMessages(prev => [...prev, errorResponse]);
        } finally {
            setIsProcessingAI(false);
        }
    };

    // Function to handle sending messages
    const handleSendMessage = () => {
        if (chatMessage.trim() === '') return;
        
        const newUserMessage = {
            id: Date.now().toString() + '_user',
            text: chatMessage.trim(),
            sender: 'user' as const,
            timestamp: new Date()
        };
        
        // Add user message to the list
        setMessages(prev => [...prev, newUserMessage]);
        
        // Clear the input
        setChatMessage('');
        
        // Add a simple acknowledgment
        setTimeout(() => {
            const ackResponse = {
                id: Date.now().toString() + '_bot_ack',
                text: "Got it! Keep adding more details, then click 'Fill Form with AI' when ready. 📝",
                sender: 'bot' as const,
                timestamp: new Date()
            };
            setMessages(prev => [...prev, ackResponse]);
        }, 1000);
    };

    // Function to load saved form data
    const loadSavedFormData = async () => {
        try {
            setIsLoadingSavedForm(true);
            const response = await axios.get('/chatbot/forms/', {
                params: { form_type: 'company_formation' },
                withCredentials: true
            });

            console.log('API Response:', response); // Debug log
            console.log('API Response Data:', response.data); // Debug log
            console.log('Response data length:', response.data ? response.data.length : 'no data');

            if (response && response.length > 0) {
                const savedForm = response[0];
                const formData = savedForm.form_data || {};
                
                console.log('Loaded form data:', formData); // Debug log
                console.log('Form data keys:', Object.keys(formData)); // Debug log
                
                // The actual form data is in the partnerOrder object
                const partnerOrder = formData.partnerOrder || {};
                console.log('Partner order data:', partnerOrder); // Debug log
                
                // Map the saved form data to formik values
                const mappedData: any = {};
                
                // Map contact information from partnerOrder.contact
                if (partnerOrder.contact) {
                    console.log('Mapping contact data from partnerOrder...');
                    mappedData.contactEmail = partnerOrder.contact.contactEmail || "";
                    mappedData.contactFirstName = partnerOrder.contact.contactFirstName || "";
                    mappedData.contactLastName = partnerOrder.contact.contactLastName || "";
                    mappedData.contactPhone = partnerOrder.contact.contactPhone || "";
                    mappedData.contactEveningPhone = partnerOrder.contact.contactEveningPhone || "";
                } else {
                    console.log('No contact data found in partnerOrder');
                }
                
                // Map company information from partnerOrder.companyInfo
                if (partnerOrder.companyInfo) {
                    console.log('Mapping company info data from partnerOrder...');
                    mappedData.companyDesiredName = partnerOrder.companyInfo.companyDesiredName || "";
                    mappedData.companyAlternativeName = partnerOrder.companyInfo.companyAlternativeName || "";
                    mappedData.companyBusinessCategory = partnerOrder.companyInfo.companyBusinessCategory || "";
                    mappedData.companyBusinessDescription = partnerOrder.companyInfo.companyBusinessDescription || "";
                } else {
                    console.log('No company info data found in partnerOrder');
                }
                
                // Map business address from partnerOrder.businessAddress
                if (partnerOrder.businessAddress) {
                    console.log('Mapping business address data from partnerOrder...');
                    mappedData.businessAddressCountry = partnerOrder.businessAddress.businessAddressCountry || DEFAULT_COUNTRY;
                    mappedData.businessAddressAddress1 = partnerOrder.businessAddress.businessAddressAddress1 || "";
                    mappedData.businessAddressAddress2 = partnerOrder.businessAddress.businessAddressAddress2 || "";
                    mappedData.businessAddressCity = partnerOrder.businessAddress.businessAddressCity || "";
                    mappedData.businessAddressState = partnerOrder.businessAddress.businessAddressState || "";
                    mappedData.businessAddressZip = partnerOrder.businessAddress.businessAddressZip || "";
                } else {
                    console.log('No business address data found in partnerOrder');
                }
                
                // Map registered agent from partnerOrder.registerAgent
                if (partnerOrder.registerAgent) {
                    console.log('Mapping registered agent data from partnerOrder...');
                    mappedData.registeredAgentIsCorpnetAgent = partnerOrder.registerAgent.registeredAgentIsCorpnetAgent || false;
                    mappedData.registeredAgentFirstName = partnerOrder.registerAgent.registeredAgentFirstName || "";
                    mappedData.registeredAgentLastName = partnerOrder.registerAgent.registeredAgentLastName || "";
                    mappedData.registeredAgentAddress1 = partnerOrder.registerAgent.registeredAgentAddress1 || "";
                    mappedData.registeredAgentAddress2 = partnerOrder.registerAgent.registeredAgentAddress2 || "";
                    mappedData.registeredAgentCity = partnerOrder.registerAgent.registeredAgentCity || "";
                    mappedData.registeredAgentState = partnerOrder.registerAgent.registeredAgentState || "";
                    mappedData.registeredAgentZip = partnerOrder.registerAgent.registeredAgentZip || "";
                    mappedData.registeredAgentCountry = partnerOrder.registerAgent.registeredAgentCountry || DEFAULT_COUNTRY;
                } else {
                    console.log('No registered agent data found in partnerOrder');
                }
                
                // Map officer information from partnerOrder.officer
                if (partnerOrder.officer) {
                    console.log('Mapping officer data from partnerOrder...');
                    mappedData.officersPresidentFirstName = partnerOrder.officer.officersPresidentFirstName || "";
                    mappedData.officersPresidentLastName = partnerOrder.officer.officersPresidentLastName || "";
                    mappedData.officersVicePresidentFirstName = partnerOrder.officer.officersVicePresidentFirstName || "";
                    mappedData.officersVicePresidentLastName = partnerOrder.officer.officersVicePresidentLastName || "";
                    mappedData.officersSecretaryFirstName = partnerOrder.officer.officersSecretaryFirstName || "";
                    mappedData.officersSecretaryLastName = partnerOrder.officer.officersSecretaryLastName || "";
                    mappedData.officersTreasurerFirstName = partnerOrder.officer.officersTreasurerFirstName || "";
                    mappedData.officersTreasurerLastName = partnerOrder.officer.officersTreasurerLastName || "";
                } else {
                    console.log('No officer data found in partnerOrder');
                }
                
                // Map LLC-specific information from partnerOrder.llcOnly
                if (partnerOrder.llcOnly && Array.isArray(partnerOrder.llcOnly) && partnerOrder.llcOnly.length > 0) {
                    console.log('Mapping LLC data from partnerOrder...');
                    // Convert llcOnly array to Formik's llcOnlyMembers array structure
                    mappedData.llcOnlyMembers = partnerOrder.llcOnly.map((llcData: any) => ({
                        firstName: llcData.llcOnlyMember1InfoFirstName || "",
                        lastName: llcData.llcOnlyMember1InfoLastName || "",
                        country: llcData.llcOnlyMember1InfoCountry || DEFAULT_COUNTRY,
                        address1: llcData.llcOnlyMember1InfoAddress1 || "",
                        address2: llcData.llcOnlyMember1InfoAddress2 || "",
                        city: llcData.llcOnlyMember1InfoCity || "",
                        state: llcData.llcOnlyMember1InfoState || DEFAULT_STATE,
                        zip: llcData.llcOnlyMember1InfoZip || "",
                        percentageOwnership: llcData.llcOnlyMember1InfoPercentageOwnership?.toString() || "",
                        itemContributed: llcData.llcOnlyMember1InfoItemContributed || "",
                        itemContributerMarketValue: llcData.llcOnlyMember1InfoItemContributerMarketValue?.toString() || "",
                        isMemberManaged: llcData.llcOnlyIsMemberManaged !== undefined ? llcData.llcOnlyIsMemberManaged : true,
                    }));
                } else {
                    console.log('No LLC data found in partnerOrder');
                }
                
                // Map LLC organizer information from partnerOrder.llcOrganizer
                if (partnerOrder.llcOrganizer) {
                    console.log('Mapping LLC organizer data from partnerOrder...');
                    mappedData.llcOnlyOrganizer = partnerOrder.llcOrganizer.llcOnlyOrganizer || "";
                    mappedData.llcOnlyOrganizerFirstName = partnerOrder.llcOrganizer.llcOnlyOrganizerFirstName || "";
                    mappedData.llcOnlyOrganizerLastName = partnerOrder.llcOrganizer.llcOnlyOrganizerLastName || "";
                    mappedData.llcOnlyOrganizerCountry = partnerOrder.llcOrganizer.llcOnlyOrganizerCountry || DEFAULT_COUNTRY;
                    mappedData.llcOnlyOrganizerAddress1 = partnerOrder.llcOrganizer.llcOnlyOrganizerAddress1 || "";
                    mappedData.llcOnlyOrganizerAddress2 = partnerOrder.llcOrganizer.llcOnlyOrganizerAddress2 || "";
                    mappedData.llcOnlyOrganizerCity = partnerOrder.llcOrganizer.llcOnlyOrganizerCity || "";
                    mappedData.llcOnlyOrganizerState = partnerOrder.llcOrganizer.llcOnlyOrganizerState || "";
                    mappedData.llcOnlyOrganizerZip = partnerOrder.llcOrganizer.llcOnlyOrganizerZip || "";
                } else {
                    console.log('No LLC organizer data found in partnerOrder');
                }
                
                // Map nonprofit incorporator information from partnerOrder.nonprofitIncorporator
                if (partnerOrder.nonprofitIncorporator) {
                    console.log('Mapping nonprofit incorporator data from partnerOrder...');
                    mappedData.nonprofitIncorporatorFirstName = partnerOrder.nonprofitIncorporator.nonprofitIncorporatorFirstName || "";
                    mappedData.nonprofitIncorporatorLastName = partnerOrder.nonprofitIncorporator.nonprofitIncorporatorLastName || "";
                    mappedData.nonprofitIncorporatorCountry = partnerOrder.nonprofitIncorporator.nonprofitIncorporatorCountry || DEFAULT_COUNTRY;
                    mappedData.nonprofitIncorporatorAddress1 = partnerOrder.nonprofitIncorporator.nonprofitIncorporatorAddress1 || "";
                    mappedData.nonprofitIncorporatorAddress2 = partnerOrder.nonprofitIncorporator.nonprofitIncorporatorAddress2 || "";
                    mappedData.nonprofitIncorporatorCity = partnerOrder.nonprofitIncorporator.nonprofitIncorporatorCity || "";
                    mappedData.nonprofitIncorporatorState = partnerOrder.nonprofitIncorporator.nonprofitIncorporatorState || "";
                    mappedData.nonprofitIncorporatorZip = partnerOrder.nonprofitIncorporator.nonprofitIncorporatorZip || "";
                } else {
                    console.log('No nonprofit incorporator data found in partnerOrder');
                }
                
                // Map corporation-specific information from partnerOrder.corporationsOnly
                if (partnerOrder.corporationsOnly) {
                    console.log('Mapping corporation data from partnerOrder...');
                    mappedData.corporationsOnlyAuthorizedShares = partnerOrder.corporationsOnly.corporationsOnlyAuthorizedShares || 1000;
                    mappedData.corporationOnlyParValue = partnerOrder.corporationsOnly.corporationOnlyParValue || 0.01;
                    mappedData.corporationOnlyDirector1InfoCountry = partnerOrder.corporationsOnly.corporationOnlyDirector1InfoCountry || DEFAULT_COUNTRY;
                    mappedData.corporationOnlyDirector1InfoAddress1 = partnerOrder.corporationsOnly.corporationOnlyDirector1InfoAddress1 || "";
                    mappedData.corporationOnlyDirector1InfoAddress2 = partnerOrder.corporationsOnly.corporationOnlyDirector1InfoAddress2 || "";
                    mappedData.corporationOnlyDirector1InfoCity = partnerOrder.corporationsOnly.corporationOnlyDirector1InfoCity || "";
                    mappedData.corporationOnlyDirector1InfoState = partnerOrder.corporationsOnly.corporationOnlyDirector1InfoState || "";
                    mappedData.corporationOnlyDirector1InfoZip = partnerOrder.corporationsOnly.corporationOnlyDirector1InfoZip || "";
                } else {
                    console.log('No corporation data found in partnerOrder');
                }
                
                // Map responsible party information from partnerOrder.responsibleParty
                if (partnerOrder.responsibleParty) {
                    console.log('Mapping responsible party data from partnerOrder...');
                    mappedData.responsibleParty = partnerOrder.responsibleParty.responsibleParty || "";
                    mappedData.responsiblePartyFirstName = partnerOrder.responsibleParty.responsiblePartyFirstName || "";
                    mappedData.responsiblePartyMiddleName = partnerOrder.responsibleParty.responsiblePartyMiddleName || "";
                    mappedData.responsiblePartyLastName = partnerOrder.responsibleParty.responsiblePartyLastName || "";
                    mappedData.responsiblePartyEmail = partnerOrder.responsibleParty.responsiblePartyEmail || "";
                    mappedData.responsiblePartyStatus = partnerOrder.responsibleParty.responsiblePartyStatus || "No";
                    mappedData.responsiblePartySSN = partnerOrder.responsibleParty.responsiblePartySSN || "";
                } else {
                    console.log('No responsible party data found in partnerOrder');
                }
                
                console.log('Mapped data for formik:', mappedData); // Debug log
                
                // Store the mapped data in state to be applied later
                setSavedFormData(mappedData);
                
                // Test: Try to set a single field directly to see if formik is working
                setTimeout(() => {
                    console.log('Testing direct formik setFieldValue...');
                    formik.setFieldValue('contactEmail', 'test@example.com');
                }, 500);
                
                // Update the bot message to indicate form was loaded
                setMessages(prev => [...prev, {
                    id: Date.now().toString() + '_bot_loaded',
                    text: "I found your previously saved form data and loaded it for you! You can continue editing or add more information. 📝",
                    sender: 'bot',
                    timestamp: new Date()
                }]);
            } else {
                console.log('No saved form data found');
                // Update the bot message to indicate no saved data was found
                setMessages(prev => [...prev, {
                    id: Date.now().toString() + '_bot_no_data',
                    text: "No previously saved form data found. You can start filling out the form or use the AI assistant to help you! 🚀",
                    sender: 'bot',
                    timestamp: new Date()
                }]);
            }
        } catch (error: any) {
            console.error('Error loading saved form data:', error);
            // Don't show error to user as this is not critical
        } finally {
            setIsLoadingSavedForm(false);
        }
    };

    // Function to save form data
    const saveFormData = async (formData: any) => {
        try {
            await axios.post('/chatbot/forms/', {
                form_type: 'company_formation',
                form_data: formData
            }, { withCredentials: true });
        } catch (error: any) {
            console.error('Error saving form data:', error);
            // Don't show error to user as this is background saving
        }
    };

    // Load saved form data on component mount
    React.useEffect(() => {
        loadSavedFormData();
    }, []);

    // Apply saved form data when it's available and formik is ready
    React.useEffect(() => {
        if (savedFormData && !isLoadingSavedForm) {
            console.log('Applying saved form data to formik:', savedFormData);
            console.log('Current formik values before update:', formik.values);
            formik.setValues(prevValues => {
                const newValues = {
                    ...prevValues,
                    ...savedFormData
                };
                console.log('Updated formik values:', newValues);
                return newValues;
            });
            setSavedFormData(null); // Clear the saved data after applying
        }
    }, [savedFormData, isLoadingSavedForm]);

    // Debug: Log formik values whenever they change
    React.useEffect(() => {
        console.log('Formik values changed:', formik.values);
    }, [formik.values]);

    // Save form data when formik values change (debounced)
    React.useEffect(() => {
        if (!isLoadingSavedForm && formik.values) {
            // Just call debouncedSave - it will get current formik values internally
        }
    }, [formik.values, isLoadingSavedForm]);

    // Auto-scroll to bottom when new messages are added
    React.useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [messages]);

    return (
        <>
        <Container fluid>
            {/* Flying Bot Avatar - Only show when form is displayed */}
            {!orderPlaced && isDevMode && (
                <div 
                    style={{
                        position: 'fixed',
                        bottom: '20px',
                        right: '20px',
                        zIndex: 9999,
                        cursor: 'pointer'
                    }}
                >
                {/* Bot Avatar */}
                <div
                    onClick={() => setShowBotChat(!showBotChat)}
                    style={{
                        width: '60px',
                        height: '60px',
                        borderRadius: '50%',
                        backgroundColor: '#007bff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'white',
                        fontSize: '24px',
                        boxShadow: '0 4px 12px rgba(0,123,255,0.3)',
                        animation: 'float 3s ease-in-out infinite',
                        transition: 'all 0.3s ease'
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'scale(1.1)';
                        e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,123,255,0.4)';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'scale(1)';
                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,123,255,0.3)';
                    }}
                >
                    <i className="bx bx-bot"></i>
                </div>

                {/* Chat Box */}
                                        {showBotChat && (
                    <div
                        style={{
                            position: 'absolute',
                            bottom: '70px',
                            right: '0',
                            width: '300px',
                            backgroundColor: 'white',
                            border: '1px solid #ddd',
                            borderRadius: '12px',
                            boxShadow: '0 8px 25px rgba(0,0,0,0.15)',
                            animation: 'slideIn 0.3s ease-out',
                            overflow: 'hidden'
                        }}
                    >
                        {/* Chat Header */}
                        <div
                            style={{
                                backgroundColor: '#007bff',
                                color: 'white',
                                padding: '12px 16px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between'
                            }}
                        >
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <i className="bx bx-bot"></i>
                                <span className="fw-medium">BizServe Assistant</span>
                            </div>
                            <button
                                onClick={() => setShowBotChat(false)}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    color: 'white',
                                    cursor: 'pointer',
                                    fontSize: '18px'
                                }}
                            >
                                <i className="bx bx-x"></i>
                            </button>
                        </div>

                        {/* Chat Content */}
                        <div style={{ padding: '16px' }}>
                            {/* Messages History */}
                            <div 
                                style={{ 
                                    maxHeight: '300px', 
                                    overflowY: 'auto',
                                    marginBottom: '12px'
                                }}
                            >
                                {messages.map((message) => (
                                    <div
                                        key={message.id}
                                        style={{
                                            marginBottom: '8px',
                                            display: 'flex',
                                            justifyContent: message.sender === 'user' ? 'flex-end' : 'flex-start'
                                        }}
                                    >
                                        <div
                                            style={{
                                                backgroundColor: message.sender === 'user' ? '#007bff' : '#f8f9fa',
                                                color: message.sender === 'user' ? 'white' : '#495057',
                                                padding: '8px 12px',
                                                borderRadius: message.sender === 'user' ? '12px 12px 4px 12px' : '12px 12px 12px 4px',
                                                fontSize: '14px',
                                                maxWidth: '80%',
                                                wordWrap: 'break-word'
                                            }}
                                        >
                                            {message.text}
                                        </div>
                                    </div>
                                ))}
                                <div ref={messagesEndRef} />
                            </div>

                            {/* Fill Form Button */}
                            {messages.some(msg => msg.sender === 'user') && (
                                <div style={{ marginBottom: '12px' }}>
                                    <button
                                        onClick={() => processWithAI(messages)}
                                        disabled={isProcessingAI}
                                        style={{
                                            width: '100%',
                                            backgroundColor: isProcessingAI ? '#6c757d' : '#28a745',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '8px',
                                            padding: '10px 16px',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            cursor: isProcessingAI ? 'not-allowed' : 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: '8px',
                                            opacity: isProcessingAI ? 0.8 : 1,
                                            transition: 'all 0.3s ease'
                                        }}
                                        onMouseEnter={(e) => {
                                            if (!isProcessingAI) {
                                                e.currentTarget.style.backgroundColor = '#218838';
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            if (!isProcessingAI) {
                                                e.currentTarget.style.backgroundColor = '#28a745';
                                            }
                                        }}
                                    >
                                        {isProcessingAI ? (
                                            <>
                                                <div
                                                    style={{
                                                        width: '16px',
                                                        height: '16px',
                                                        border: '2px solid #ffffff',
                                                        borderTop: '2px solid transparent',
                                                        borderRadius: '50%',
                                                        animation: 'spin 1s linear infinite'
                                                    }}
                                                />
                                                Processing...
                                            </>
                                        ) : (
                                            <>
                                                <i className="bx bx-magic-wand"></i>
                                                Fill Form with AI
                                            </>
                                        )}
                                    </button>
                                </div>
                            )}

                            {/* Message Input */}
                            <div style={{ display: 'flex', gap: '8px' }}>
                                <input
                                    type="text"
                                    value={chatMessage}
                                    onChange={(e) => setChatMessage(e.target.value)}
                                    placeholder="Type your question..."
                                    style={{
                                        flex: 1,
                                        padding: '8px 12px',
                                        border: '1px solid #ddd',
                                        borderRadius: '20px',
                                        fontSize: '14px',
                                        outline: 'none'
                                    }}
                                    onKeyUp={(e) => {
                                        if (e.key === 'Enter') {
                                            handleSendMessage();
                                        }
                                    }}
                                />
                                <button
                                    onClick={handleSendMessage}
                                    style={{
                                        backgroundColor: '#007bff',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '50%',
                                        width: '36px',
                                        height: '36px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        cursor: 'pointer'
                                    }}
                                >
                                    <i className="bx bx-send"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                )}
                </div>
            )}

            <Row className="justify-content-center">
                <Col xs={12}>
                    <Card>
                        <CardBody style={{ backgroundColor: '#f8f9fa', color: '#212529' }}>
                            {/* Alert message */}
                            {alertMsg.open && (
                                <Alert color={alertMsg.type === 'success' ? 'success' : 'danger'} toggle={() => setAlertMsg({ ...alertMsg, open: false })} fade={false} style={{ fontWeight: 'bold' }}>
                                    {alertMsg.content}
                                </Alert>
                            )}
                            {orderPlaced ? (
                                <div className="text-center py-5">
                                    <div style={{ fontSize: 72, color: '#28a745' }}>
                                        <i className="bx bx-check-circle"></i>
                                    </div>
                                    <h2 className="mt-3 mb-2">Order Placed!</h2>
                                    <div className="mb-2">Your order has been placed successfully.</div>
                                    <div className="fw-bold">Order ID: {orderPlaced}</div>
                                </div>
                            ) : (
                                <>
                                    {/* Title above the form */}
                                    <h3 className="mb-4" style={{ fontWeight: 600 }}>Please fill in these details.</h3>
                                    {/* Display selected package name and total price */}
                                    <div className="mb-3">
                                        {packageName && (
                                            <h5>Selected Package: <span className="text-primary">{packageName}</span></h5>
                                        )}
                                        <div>Total Price: <span className="fw-bold">${orderTotalPrice}</span></div>
                                    </div>
                                    
                                    {/* Loading indicator for saved form data */}
                                    {isLoadingSavedForm && (
                                        <div className="text-center mb-3">
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                            <div className="mt-2">Loading your saved form data...</div>
                                        </div>
                                    )}
                                    <Form onSubmit={formik.handleSubmit}>
                                        <Row>
                                            {/* Left column: Contact + Company in separate cards */}
                                            <Col md={6}>
                                                <Card className="mb-4">
                                                    <CardBody>
                                                        <h6 className="fw-bold mb-3">Contact Information</h6>
                                                        <Row>
                                                            <Col md={6}>
                                                                <FormGroup>
                                                                    <Label>Email <span className="text-danger">*</span></Label>
                                                                    <Input
                                                                        name="contactEmail"
                                                                        type="email"
                                                                        value={formik.values.contactEmail}
                                                                        onChange={formik.handleChange}
                                                                        onBlur={formik.handleBlur}
                                                                        invalid={!!(formik.touched.contactEmail && formik.errors.contactEmail)}
                                                                    />
                                                                    <FormFeedback>{formik.errors.contactEmail}</FormFeedback>
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={6}>
                                                                <FormGroup>
                                                                    <Label>First Name <span className="text-danger">*</span></Label>
                                                                    <Input
                                                                        name="contactFirstName"
                                                                        value={formik.values.contactFirstName}
                                                                        onChange={formik.handleChange}
                                                                        onBlur={formik.handleBlur}
                                                                        invalid={!!(formik.touched.contactFirstName && formik.errors.contactFirstName)}
                                                                    />
                                                                    <FormFeedback>{formik.errors.contactFirstName}</FormFeedback>
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col md={6}>
                                                                <FormGroup>
                                                                    <Label>Last Name <span className="text-danger">*</span></Label>
                                                                    <Input
                                                                        name="contactLastName"
                                                                        value={formik.values.contactLastName}
                                                                        onChange={formik.handleChange}
                                                                        onBlur={formik.handleBlur}
                                                                        invalid={!!(formik.touched.contactLastName && formik.errors.contactLastName)}
                                                                    />
                                                                    <FormFeedback>{formik.errors.contactLastName}</FormFeedback>
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={6}>
                                                                <FormGroup>
                                                                    <Label>Phone <span className="text-danger">*</span></Label>
                                                                    <Input
                                                                        name="contactPhone"
                                                                        value={formik.values.contactPhone}
                                                                        onChange={formik.handleChange}
                                                                        onBlur={formik.handleBlur}
                                                                        invalid={!!(formik.touched.contactPhone && formik.errors.contactPhone)}
                                                                    />
                                                                    <FormFeedback>{formik.errors.contactPhone}</FormFeedback>
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col md={6}>
                                                                <FormGroup>
                                                                    <Label>Evening Phone</Label>
                                                                    <Input
                                                                        name="contactEveningPhone"
                                                                        value={formik.values.contactEveningPhone}
                                                                        onChange={formik.handleChange}
                                                                        onBlur={formik.handleBlur}
                                                                        invalid={!!(formik.touched.contactEveningPhone && formik.errors.contactEveningPhone)}
                                                                    />
                                                                    <FormFeedback>{formik.errors.contactEveningPhone}</FormFeedback>
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                    </CardBody>
                                                </Card>
                                                <Card>
                                                    <CardBody>
                                                        <h6 className="fw-bold mb-3">Company Information</h6>
                                                        <Row>
                                                            <Col md={6}>
                                                                <FormGroup>
                                                                    <Label>Desired Name <span className="text-danger">*</span></Label>
                                                                    <Input
                                                                        name="companyDesiredName"
                                                                        value={formik.values.companyDesiredName}
                                                                        onChange={formik.handleChange}
                                                                        onBlur={formik.handleBlur}
                                                                        invalid={!!(formik.touched.companyDesiredName && formik.errors.companyDesiredName)}
                                                                    />
                                                                    <FormFeedback>{formik.errors.companyDesiredName}</FormFeedback>
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={6}>
                                                                <FormGroup>
                                                                    <Label>
                                                                        Alternative Name
                                                                        <i className="bx bx-info-circle ms-2" id="companyAlternativeName-tooltip" style={{ cursor: 'help' }}></i>
                                                                        <UncontrolledTooltip placement="top" target="companyAlternativeName-tooltip">
                                                                            Optional alternative business name (max length - 1023 characters)
                                                                        </UncontrolledTooltip>
                                                                    </Label>
                                                                    <Input
                                                                        name="companyAlternativeName"
                                                                        value={formik.values.companyAlternativeName}
                                                                        onChange={formik.handleChange}
                                                                        onBlur={formik.handleBlur}
                                                                        invalid={!!(formik.touched.companyAlternativeName && formik.errors.companyAlternativeName)}
                                                                    />
                                                                    <FormFeedback>{formik.errors.companyAlternativeName}</FormFeedback>
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col md={6}>
                                                                <FormGroup>
                                                                    <Label>
                                                                        Business Category <span className="text-danger">*</span>
                                                                        <i className="bx bx-info-circle ms-2" id="companyBusinessCategory-tooltip" style={{ cursor: 'help' }}></i>
                                                                        <UncontrolledTooltip placement="top" target="companyBusinessCategory-tooltip">
                                                                            Category of business operations (e.g., retail, services)
                                                                        </UncontrolledTooltip>
                                                                    </Label>
                                                                    <Input
                                                                        type="select"
                                                                        name="companyBusinessCategory"
                                                                        value={formik.values.companyBusinessCategory}
                                                                        onChange={formik.handleChange}
                                                                        onBlur={formik.handleBlur}
                                                                        invalid={!!(formik.touched.companyBusinessCategory && formik.errors.companyBusinessCategory)}
                                                                    >
                                                                        <option value="">Select category</option>
                                                                        <option value="retail">Retail</option>
                                                                        <option value="services">Services</option>
                                                                        <option value="other">Other</option>
                                                                    </Input>
                                                                    <FormFeedback>{formik.errors.companyBusinessCategory}</FormFeedback>
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={12}>
                                                                <FormGroup>
                                                                    <Label>
                                                                        Business Description <span className="text-danger">*</span>
                                                                        <i className="bx bx-info-circle ms-2" id="companyBusinessDescription-tooltip" style={{ cursor: 'help' }}></i>
                                                                        <UncontrolledTooltip placement="top" target="companyBusinessDescription-tooltip">
                                                                            Brief description of the business activities (max length - 1023 characters)
                                                                        </UncontrolledTooltip>
                                                                    </Label>
                                                                    <Input
                                                                        name="companyBusinessDescription"
                                                                        type="textarea"
                                                                        value={formik.values.companyBusinessDescription}
                                                                        onChange={formik.handleChange}
                                                                        onBlur={formik.handleBlur}
                                                                        invalid={!!(formik.touched.companyBusinessDescription && formik.errors.companyBusinessDescription)}
                                                                    />
                                                                    <FormFeedback>{formik.errors.companyBusinessDescription}</FormFeedback>
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                    </CardBody>
                                                </Card>
                                            </Col>
                                            {/* Right column: Business Address + Registered Agent in separate cards */}
                                            <Col md={6}>
                                                <Card className="mb-4">
                                                    <CardBody>
                                                        <h6 className="fw-bold mb-3">Business Address</h6>
                                                        <Row>
                                                            <Col md={6}>
                                                                <FormGroup>
                                                                    <Label>Country <span className="text-danger">*</span></Label>
                                                                    <Input
                                                                        type="select"
                                                                        name="businessAddressCountry"
                                                                        value={formik.values.businessAddressCountry}
                                                                        onChange={(e) => handleCountryChange("businessAddressCountry", "businessAddressState", e.target.value)}
                                                                        onBlur={formik.handleBlur}
                                                                        invalid={!!(formik.touched.businessAddressCountry && formik.errors.businessAddressCountry)}
                                                                    >
                                                                        <option value="">Select country</option>
                                                                        {COUNTRY_OPTIONS.map((country) => (
                                                                            <option key={country.code} value={country.code}>
                                                                                {country.label}
                                                                            </option>
                                                                        ))}
                                                                    </Input>
                                                                    <FormFeedback>{formik.errors.businessAddressCountry}</FormFeedback>
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={6}>
                                                                <FormGroup>
                                                                    <Label>Address 1 <span className="text-danger">*</span></Label>
                                                                    <Input
                                                                        name="businessAddressAddress1"
                                                                        value={formik.values.businessAddressAddress1}
                                                                        onChange={formik.handleChange}
                                                                        onBlur={formik.handleBlur}
                                                                        invalid={!!(formik.touched.businessAddressAddress1 && formik.errors.businessAddressAddress1)}
                                                                    />
                                                                    <FormFeedback>{formik.errors.businessAddressAddress1}</FormFeedback>
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col md={6}>
                                                                <FormGroup>
                                                                    <Label>Address 2</Label>
                                                                    <Input
                                                                        name="businessAddressAddress2"
                                                                        value={formik.values.businessAddressAddress2}
                                                                        onChange={formik.handleChange}
                                                                        onBlur={formik.handleBlur}
                                                                        invalid={!!(formik.touched.businessAddressAddress2 && formik.errors.businessAddressAddress2)}
                                                                    />
                                                                    <FormFeedback>{formik.errors.businessAddressAddress2}</FormFeedback>
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={6}>
                                                                <FormGroup>
                                                                    <Label>City <span className="text-danger">*</span></Label>
                                                                    <Input
                                                                        name="businessAddressCity"
                                                                        value={formik.values.businessAddressCity}
                                                                        onChange={formik.handleChange}
                                                                        onBlur={formik.handleBlur}
                                                                        invalid={!!(formik.touched.businessAddressCity && formik.errors.businessAddressCity)}
                                                                    />
                                                                    <FormFeedback>{formik.errors.businessAddressCity}</FormFeedback>
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col md={6}>
                                                                <FormGroup>
                                                                    <Label>State <span className="text-danger">*</span></Label>
                                                                    {formik.values.businessAddressCountry === DEFAULT_COUNTRY ? (
                                                                        <Input
                                                                            type="select"
                                                                            name="businessAddressState"
                                                                            value={formik.values.businessAddressState}
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                            invalid={!!(formik.touched.businessAddressState && formik.errors.businessAddressState)}
                                                                        >
                                                                            <option value="">Select state</option>
                                                                            {US_STATES.map((state) => (
                                                                                <option key={state.value} value={state.value}>
                                                                                    {state.label}
                                                                                </option>
                                                                            ))}
                                                                        </Input>
                                                                    ) : (
                                                                        <Input
                                                                            name="businessAddressState"
                                                                            placeholder="State / Province"
                                                                            value={formik.values.businessAddressState}
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                            invalid={!!(formik.touched.businessAddressState && formik.errors.businessAddressState)}
                                                                        />
                                                                    )}
                                                                    <FormFeedback>{formik.errors.businessAddressState}</FormFeedback>
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={6}>
                                                                <FormGroup>
                                                                    <Label>Zip <span className="text-danger">*</span></Label>
                                                                    <Input
                                                                        type="text"
                                                                        name="businessAddressZip"
                                                                        placeholder="12345"
                                                                        value={formik.values.businessAddressZip}
                                                                        onChange={formik.handleChange}
                                                                        onBlur={formik.handleBlur}
                                                                        invalid={!!(formik.touched.businessAddressZip && formik.errors.businessAddressZip)}
                                                                    />
                                                                    <FormFeedback>{formik.errors.businessAddressZip}</FormFeedback>
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                    </CardBody>
                                                </Card>
                                                <Card>
                                                    <CardBody>
                                                        <h6 className="fw-bold mb-3">Registered Agent</h6>
                                                        <FormGroup check className="mb-2">
                                                            <Label check>
                                                                <Input
                                                                    type="checkbox"
                                                                    name="registeredAgentIsCorpnetAgent"
                                                                    checked={formik.values.registeredAgentIsCorpnetAgent}
                                                                    onChange={formik.handleChange}
                                                                />
                                                                Do you need us as your Agent?
                                                                <i className="bx bx-info-circle ms-2" id="registeredAgentIsCorpnetAgent-tooltip" style={{ cursor: 'help' }}></i>
                                                                <UncontrolledTooltip placement="top" target="registeredAgentIsCorpnetAgent-tooltip">
                                                                    A registered agent receives official government documents and legal notices on behalf of your business. If CorpNet acts as your agent, you don't need to provide agent details.
                                                                </UncontrolledTooltip>
                                                            </Label>
                                                        </FormGroup>
                                                        {!formik.values.registeredAgentIsCorpnetAgent && (
                                                            <>
                                                                <Row>
                                                                    <Col md={6}>
                                                                        <FormGroup>
                                                                            <Label>First Name <span className="text-danger">*</span></Label>
                                                                            <Input
                                                                                name="registeredAgentFirstName"
                                                                                value={formik.values.registeredAgentFirstName}
                                                                                onChange={formik.handleChange}
                                                                                onBlur={formik.handleBlur}
                                                                                invalid={!!(formik.touched.registeredAgentFirstName && formik.errors.registeredAgentFirstName)}
                                                                            />
                                                                            <FormFeedback>{formik.errors.registeredAgentFirstName}</FormFeedback>
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col md={6}>
                                                                        <FormGroup>
                                                                            <Label>Last Name <span className="text-danger">*</span></Label>
                                                                            <Input
                                                                                name="registeredAgentLastName"
                                                                                value={formik.values.registeredAgentLastName}
                                                                                onChange={formik.handleChange}
                                                                                onBlur={formik.handleBlur}
                                                                                invalid={!!(formik.touched.registeredAgentLastName && formik.errors.registeredAgentLastName)}
                                                                            />
                                                                            <FormFeedback>{formik.errors.registeredAgentLastName}</FormFeedback>
                                                                        </FormGroup>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col md={6}>
                                                                        <FormGroup>
                                                                            <Label>Address 1 <span className="text-danger">*</span></Label>
                                                                            <Input
                                                                                name="registeredAgentAddress1"
                                                                                value={formik.values.registeredAgentAddress1}
                                                                                onChange={formik.handleChange}
                                                                                onBlur={formik.handleBlur}
                                                                                invalid={!!(formik.touched.registeredAgentAddress1 && formik.errors.registeredAgentAddress1)}
                                                                            />
                                                                            <FormFeedback>{formik.errors.registeredAgentAddress1}</FormFeedback>
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col md={6}>
                                                                        <FormGroup>
                                                                            <Label>Address 2</Label>
                                                                            <Input
                                                                                name="registeredAgentAddress2"
                                                                                value={formik.values.registeredAgentAddress2}
                                                                                onChange={formik.handleChange}
                                                                                onBlur={formik.handleBlur}
                                                                                invalid={!!(formik.touched.registeredAgentAddress2 && formik.errors.registeredAgentAddress2)}
                                                                            />
                                                                            <FormFeedback>{formik.errors.registeredAgentAddress2}</FormFeedback>
                                                                        </FormGroup>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col md={6}>
                                                                        <FormGroup>
                                                                            <Label>City <span className="text-danger">*</span></Label>
                                                                            <Input
                                                                                name="registeredAgentCity"
                                                                                value={formik.values.registeredAgentCity}
                                                                                onChange={formik.handleChange}
                                                                                onBlur={formik.handleBlur}
                                                                                invalid={!!(formik.touched.registeredAgentCity && formik.errors.registeredAgentCity)}
                                                                            />
                                                                            <FormFeedback>{formik.errors.registeredAgentCity}</FormFeedback>
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col md={6}>
                                                                        <FormGroup>
                                                                            <Label>State <span className="text-danger">*</span></Label>
                                                                            {formik.values.registeredAgentCountry === DEFAULT_COUNTRY ? (
                                                                                <Input
                                                                                    type="select"
                                                                                    name="registeredAgentState"
                                                                                    value={formik.values.registeredAgentState}
                                                                                    onChange={formik.handleChange}
                                                                                    onBlur={formik.handleBlur}
                                                                                    invalid={!!(formik.touched.registeredAgentState && formik.errors.registeredAgentState)}
                                                                                >
                                                                                    <option value="">Select state</option>
                                                                                    {US_STATES.map((state) => (
                                                                                        <option key={state.value} value={state.value}>
                                                                                            {state.label}
                                                                                        </option>
                                                                                    ))}
                                                                                </Input>
                                                                            ) : (
                                                                                <Input
                                                                                    name="registeredAgentState"
                                                                                    placeholder="State / Province"
                                                                                    value={formik.values.registeredAgentState}
                                                                                    onChange={formik.handleChange}
                                                                                    onBlur={formik.handleBlur}
                                                                                    invalid={!!(formik.touched.registeredAgentState && formik.errors.registeredAgentState)}
                                                                                />
                                                                            )}
                                                                            <FormFeedback>{formik.errors.registeredAgentState}</FormFeedback>
                                                                        </FormGroup>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col md={6}>
                                                                        <FormGroup>
                                                                            <Label>Zip <span className="text-danger">*</span></Label>
                                                                            <Input
                                                                                type="text"
                                                                                name="registeredAgentZip"
                                                                                placeholder="12345"
                                                                                value={formik.values.registeredAgentZip}
                                                                                onChange={formik.handleChange}
                                                                                onBlur={formik.handleBlur}
                                                                                invalid={!!(formik.touched.registeredAgentZip && formik.errors.registeredAgentZip)}
                                                                            />
                                                                            <FormFeedback>{formik.errors.registeredAgentZip}</FormFeedback>
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col md={6}>
                                                                        <FormGroup>
                                                                            <Label>Country <span className="text-danger">*</span></Label>
                                                                            <Input
                                                                                type="select"
                                                                                name="registeredAgentCountry"
                                                                                value={formik.values.registeredAgentCountry}
                                                                                onChange={(e) => handleCountryChange("registeredAgentCountry", "registeredAgentState", e.target.value)}
                                                                                onBlur={formik.handleBlur}
                                                                                invalid={!!(formik.touched.registeredAgentCountry && formik.errors.registeredAgentCountry)}
                                                                            >
                                                                                <option value="">Select country</option>
                                                                                {COUNTRY_OPTIONS.map((country) => (
                                                                                    <option key={country.code} value={country.code}>
                                                                                        {country.label}
                                                                                    </option>
                                                                                ))}
                                                                            </Input>
                                                                            <FormFeedback>{formik.errors.registeredAgentCountry}</FormFeedback>
                                                                        </FormGroup>
                                                                    </Col>
                                                                </Row>
                                                            </>
                                                        )}
                                                    </CardBody>
                                                </Card>
                                            </Col>
                                        </Row>
                                        
                                        {/* Officers Section - Only show for Corporations */}
                                        {(businessStructureType === "C-Corporation" || businessStructureType === "S-Corporation" || businessStructureType === "Professional Corporation") && (
                                            <Row>
                                                <Col xs={12}>
                                                    <Card className="mb-4">
                                                        <CardBody>
                                                            <h6 className="fw-bold mb-3">Officers Information</h6>
                                                            <Row>
                                                                <Label>President <span className="text-danger">*</span></Label>
                                                                <Col md={6}>
                                                                    <FormGroup>
                                                                        <Label className="small text-muted">First Name</Label>
                                                                        <Input
                                                                            name="officersPresidentFirstName"
                                                                            value={formik.values.officersPresidentFirstName}
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                            invalid={!!(formik.touched.officersPresidentFirstName && formik.errors.officersPresidentFirstName)}
                                                                        />
                                                                        <FormFeedback>{formik.errors.officersPresidentFirstName}</FormFeedback>
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col md={6}>
                                                                    <FormGroup>
                                                                        <Label className="small text-muted">Last Name</Label>
                                                                        <Input
                                                                            name="officersPresidentLastName"
                                                                            value={formik.values.officersPresidentLastName}
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                            invalid={!!(formik.touched.officersPresidentLastName && formik.errors.officersPresidentLastName)}
                                                                        />
                                                                        <FormFeedback>{formik.errors.officersPresidentLastName}</FormFeedback>
                                                                    </FormGroup>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Label>Vice President</Label>
                                                                <Col md={6}>
                                                                    <FormGroup>
                                                                        <Label className="small text-muted">First Name</Label>
                                                                        <Input
                                                                            name="officersVicePresidentFirstName"
                                                                            value={formik.values.officersVicePresidentFirstName}
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                            invalid={!!(formik.touched.officersVicePresidentFirstName && formik.errors.officersVicePresidentFirstName)}
                                                                        />
                                                                        <FormFeedback>{formik.errors.officersVicePresidentFirstName}</FormFeedback>
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col md={6}>
                                                                    <FormGroup>
                                                                        <Label className="small text-muted">Last Name</Label>
                                                                        <Input
                                                                            name="officersVicePresidentLastName"
                                                                            value={formik.values.officersVicePresidentLastName}
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                            invalid={!!(formik.touched.officersVicePresidentLastName && formik.errors.officersVicePresidentLastName)}
                                                                        />
                                                                        <FormFeedback>{formik.errors.officersVicePresidentLastName}</FormFeedback>
                                                                    </FormGroup>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Label>Secretary</Label>
                                                                <Col md={6}>
                                                                    <FormGroup>
                                                                        <Label className="small text-muted">First Name</Label>
                                                                        <Input
                                                                            name="officersSecretaryFirstName"
                                                                            value={formik.values.officersSecretaryFirstName}
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                            invalid={!!(formik.touched.officersSecretaryFirstName && formik.errors.officersSecretaryFirstName)}
                                                                        />
                                                                        <FormFeedback>{formik.errors.officersSecretaryFirstName}</FormFeedback>
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col md={6}>
                                                                    <FormGroup>
                                                                        <Label className="small text-muted">Last Name</Label>
                                                                        <Input
                                                                            name="officersSecretaryLastName"
                                                                            value={formik.values.officersSecretaryLastName}
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                            invalid={!!(formik.touched.officersSecretaryLastName && formik.errors.officersSecretaryLastName)}
                                                                        />
                                                                        <FormFeedback>{formik.errors.officersSecretaryLastName}</FormFeedback>
                                                                    </FormGroup>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Label>Treasurer</Label>
                                                                <Col md={6}>
                                                                    <FormGroup>
                                                                        <Label className="small text-muted">First Name</Label>
                                                                        <Input
                                                                            name="officersTreasurerFirstName"
                                                                            value={formik.values.officersTreasurerFirstName}
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                            invalid={!!(formik.touched.officersTreasurerFirstName && formik.errors.officersTreasurerFirstName)}
                                                                        />
                                                                        <FormFeedback>{formik.errors.officersTreasurerFirstName}</FormFeedback>
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col md={6}>
                                                                    <FormGroup>
                                                                        <Label className="small text-muted">Last Name</Label>
                                                                        <Input
                                                                            name="officersTreasurerLastName"
                                                                            value={formik.values.officersTreasurerLastName}
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                            invalid={!!(formik.touched.officersTreasurerLastName && formik.errors.officersTreasurerLastName)}
                                                                        />
                                                                        <FormFeedback>{formik.errors.officersTreasurerLastName}</FormFeedback>
                                                                    </FormGroup>
                                                                </Col>
                                                            </Row>
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                            </Row>
                                        )}
                                        
                                        {/* LLC Specific Section - Only show for LLC */}
                                        {businessStructureType === "LLC" && (
                                            <>
                                                <Row>
                                                    <Col xs={12}>
                                                        <Card className="mb-4">
                                                            <CardBody>
                                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                                    <h6 className="fw-bold mb-0">LLC Member Information</h6>
                                                                    <Button 
                                                                        type="button"
                                                                        color="success" 
                                                                        size="sm"
                                                                        onClick={() => {
                                                                            const newMembers = [...(formik.values.llcOnlyMembers || [])];
                                                                            newMembers.push({
                                                                                firstName: "",
                                                                                lastName: "",
                                                                                country: DEFAULT_COUNTRY,
                                                                                address1: "",
                                                                                address2: "",
                                                                                city: "",
                                                                                state: DEFAULT_STATE,
                                                                                zip: "",
                                                                                percentageOwnership: "",
                                                                                itemContributed: "",
                                                                                itemContributerMarketValue: "",
                                                                                isMemberManaged: true,
                                                                            });
                                                                            formik.setFieldValue("llcOnlyMembers", newMembers);
                                                                        }}
                                                                    >
                                                                        <i className="bx bx-plus"></i> Add Member
                                                                    </Button>
                                                                </div>
                                                                
                                                                
                                                                {/* Total Ownership Percentage Display */}
                                                                <div className="mb-3 p-2 bg-light rounded">
                                                                    <small className="text-muted">
                                                                        Total Ownership: <strong>
                                                                            {(formik.values.llcOnlyMembers || []).reduce((total: number, member: any) => {
                                                                                const percentage = parseFloat(member.percentageOwnership) || 0;
                                                                                return total + percentage;
                                                                            }, 0).toFixed(1)}%
                                                                        </strong>
                                                                        {(formik.errors.llcOnlyMembers as any)?.message && (
                                                                            <span className="text-danger ms-2">
                                                                                {(formik.errors.llcOnlyMembers as any).message}
                                                                            </span>
                                                                        )}
                                                                    </small>
                                                                </div>

                                                                {(formik.values.llcOnlyMembers || []).map((member: any, index: number) => (
                                                                    <div key={index} className="border rounded p-3 mb-3">
                                                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                                                            <h6 className="fw-bold mb-0">Member {index + 1}</h6>
                                                                            {(formik.values.llcOnlyMembers || []).length > 1 ? (
                                                                                <Button 
                                                                                    type="button"
                                                                                    color="danger" 
                                                                                    size="sm"
                                                                                    onClick={() => {
                                                                                        const newMembers = [...(formik.values.llcOnlyMembers || [])];
                                                                                        newMembers.splice(index, 1);
                                                                                        formik.setFieldValue("llcOnlyMembers", newMembers);
                                                                                    }}
                                                                                >
                                                                                    <i className="bx bx-trash"></i> Remove
                                                                                </Button>
                                                                            ) : (
                                                                                <small className="text-muted">
                                                                                    <i className="bx bx-info-circle"></i> At least one member required
                                                                                </small>
                                                                            )}
                                                                        </div>
                                                                        
                                                                        {/* Member-managed checkbox for this specific member */}
                                                                        <FormGroup check className="mb-3">
                                                                            <Label check>
                                                                                <Input
                                                                                    type="checkbox"
                                                                                    checked={member.isMemberManaged}
                                                                                    onChange={(e) => {
                                                                                        const newMembers = [...(formik.values.llcOnlyMembers || [])];
                                                                                        newMembers[index].isMemberManaged = e.target.checked;
                                                                                        formik.setFieldValue("llcOnlyMembers", newMembers);
                                                                                    }}
                                                                                />
                                                                                Member-managed LLC
                                                                                <i className="bx bx-info-circle ms-2" id={`isMemberManaged-tooltip-${index}`} style={{ cursor: 'help' }}></i>
                                                                                <UncontrolledTooltip placement="top" target={`isMemberManaged-tooltip-${index}`}>
                                                                                    Indicates if the LLC is member-managed (members make decisions) or manager-managed (appointed managers make decisions)
                                                                                </UncontrolledTooltip>
                                                                            </Label>
                                                                        </FormGroup>
                                                                        
                                                                        <Row>
                                                                            <Col md={6}>
                                                                                <FormGroup>
                                                                                    <Label>First Name <span className="text-danger">*</span></Label>
                                                                                    <Input
                                                                                        name={`llcOnlyMembers[${index}].firstName`}
                                                                                        value={member.firstName}
                                                                                        onChange={(e) => {
                                                                                            const newMembers = [...(formik.values.llcOnlyMembers || [])];
                                                                                            newMembers[index].firstName = e.target.value;
                                                                                            formik.setFieldValue("llcOnlyMembers", newMembers);
                                                                                        }}
                                                                                        onBlur={formik.handleBlur}
                                                                                        invalid={!!(formik.touched.llcOnlyMembers?.[index]?.firstName && (formik.errors.llcOnlyMembers as any)?.[index]?.firstName)}
                                                                                    />
                                                                                    <FormFeedback>{(formik.errors.llcOnlyMembers as any)?.[index]?.firstName}</FormFeedback>
                                                                                </FormGroup>
                                                                            </Col>
                                                                            <Col md={6}>
                                                                                <FormGroup>
                                                                                    <Label>Last Name <span className="text-danger">*</span></Label>
                                                                                    <Input
                                                                                        name={`llcOnlyMembers[${index}].lastName`}
                                                                                        value={member.lastName}
                                                                                        onChange={(e) => {
                                                                                            const newMembers = [...(formik.values.llcOnlyMembers || [])];
                                                                                            newMembers[index].lastName = e.target.value;
                                                                                            formik.setFieldValue("llcOnlyMembers", newMembers);
                                                                                        }}
                                                                                        onBlur={formik.handleBlur}
                                                                                        invalid={!!(formik.touched.llcOnlyMembers?.[index]?.lastName && (formik.errors.llcOnlyMembers as any)?.[index]?.lastName)}
                                                                                    />
                                                                                    <FormFeedback>{(formik.errors.llcOnlyMembers as any)?.[index]?.lastName}</FormFeedback>
                                                                                </FormGroup>
                                                                            </Col>
                                                                        </Row>
                                                                        
                                                                        <Row>
                                                                            <Col md={6}>
                                                                                <FormGroup>
                                                                                    <Label>Country <span className="text-danger">*</span></Label>
                                                                                    <Input
                                                                                        type="select"
                                                                                        name={`llcOnlyMembers[${index}].country`}
                                                                                        value={member.country}
                                                                                        onChange={(e) => {
                                                                                            const newMembers = [...(formik.values.llcOnlyMembers || [])];
                                                                                            const selectedCountry = e.target.value;
                                                                                            newMembers[index].country = selectedCountry;
                                                                                            newMembers[index].state = selectedCountry === DEFAULT_COUNTRY ? DEFAULT_STATE : "";
                                                                                            formik.setFieldValue("llcOnlyMembers", newMembers);
                                                                                        }}
                                                                                        onBlur={formik.handleBlur}
                                                                                        invalid={!!(formik.touched.llcOnlyMembers?.[index]?.country && (formik.errors.llcOnlyMembers as any)?.[index]?.country)}
                                                                                    >
                                                                                        <option value="">Select country</option>
                                                                                        {COUNTRY_OPTIONS.map((country) => (
                                                                                            <option key={country.code} value={country.code}>
                                                                                                {country.label}
                                                                                            </option>
                                                                                        ))}
                                                                                    </Input>
                                                                                    <FormFeedback>{(formik.errors.llcOnlyMembers as any)?.[index]?.country}</FormFeedback>
                                                                                </FormGroup>
                                                                            </Col>
                                                                            <Col md={6}>
                                                                                <FormGroup>
                                                                                    <Label>Address 1 <span className="text-danger">*</span></Label>
                                                                                    <Input
                                                                                        name={`llcOnlyMembers[${index}].address1`}
                                                                                        value={member.address1}
                                                                                        onChange={(e) => {
                                                                                            const newMembers = [...(formik.values.llcOnlyMembers || [])];
                                                                                            newMembers[index].address1 = e.target.value;
                                                                                            formik.setFieldValue("llcOnlyMembers", newMembers);
                                                                                        }}
                                                                                        onBlur={formik.handleBlur}
                                                                                        invalid={!!(formik.touched.llcOnlyMembers?.[index]?.address1 && (formik.errors.llcOnlyMembers as any)?.[index]?.address1)}
                                                                                    />
                                                                                    <FormFeedback>{(formik.errors.llcOnlyMembers as any)?.[index]?.address1}</FormFeedback>
                                                                                </FormGroup>
                                                                            </Col>
                                                                        </Row>
                                                                        
                                                                        <Row>
                                                                            <Col md={6}>
                                                                                <FormGroup>
                                                                                    <Label>Address 2</Label>
                                                                                    <Input
                                                                                        name={`llcOnlyMembers[${index}].address2`}
                                                                                        value={member.address2}
                                                                                        onChange={(e) => {
                                                                                            const newMembers = [...(formik.values.llcOnlyMembers || [])];
                                                                                            newMembers[index].address2 = e.target.value;
                                                                                            formik.setFieldValue("llcOnlyMembers", newMembers);
                                                                                        }}
                                                                                        onBlur={formik.handleBlur}
                                                                                        invalid={!!(formik.touched.llcOnlyMembers?.[index]?.address2 && (formik.errors.llcOnlyMembers as any)?.[index]?.address2)}
                                                                                    />
                                                                                    <FormFeedback>{(formik.errors.llcOnlyMembers as any)?.[index]?.address2}</FormFeedback>
                                                                                </FormGroup>
                                                                            </Col>
                                                                            <Col md={6}>
                                                                                <FormGroup>
                                                                                    <Label>City <span className="text-danger">*</span></Label>
                                                                                    <Input
                                                                                        name={`llcOnlyMembers[${index}].city`}
                                                                                        value={member.city}
                                                                                        onChange={(e) => {
                                                                                            const newMembers = [...(formik.values.llcOnlyMembers || [])];
                                                                                            newMembers[index].city = e.target.value;
                                                                                            formik.setFieldValue("llcOnlyMembers", newMembers);
                                                                                        }}
                                                                                        onBlur={formik.handleBlur}
                                                                                        invalid={!!(formik.touched.llcOnlyMembers?.[index]?.city && (formik.errors.llcOnlyMembers as any)?.[index]?.city)}
                                                                                    />
                                                                                    <FormFeedback>{(formik.errors.llcOnlyMembers as any)?.[index]?.city}</FormFeedback>
                                                                                </FormGroup>
                                                                            </Col>
                                                                        </Row>
                                                                        
                                                                        <Row>
                                                                            <Col md={6}>
                                                                                <FormGroup>
                                                                                    <Label>State <span className="text-danger">*</span></Label>
                                                                                    {member.country === DEFAULT_COUNTRY ? (
                                                                                        <Input
                                                                                            type="select"
                                                                                            name={`llcOnlyMembers[${index}].state`}
                                                                                            value={member.state}
                                                                                            onChange={(e) => {
                                                                                                const newMembers = [...(formik.values.llcOnlyMembers || [])];
                                                                                                newMembers[index].state = e.target.value;
                                                                                                formik.setFieldValue("llcOnlyMembers", newMembers);
                                                                                            }}
                                                                                            onBlur={formik.handleBlur}
                                                                                            invalid={!!(formik.touched.llcOnlyMembers?.[index]?.state && (formik.errors.llcOnlyMembers as any)?.[index]?.state)}
                                                                                        >
                                                                                            <option value="">Select state</option>
                                                                                            {US_STATES.map((state) => (
                                                                                                <option key={state.value} value={state.value}>
                                                                                                    {state.label}
                                                                                                </option>
                                                                                            ))}
                                                                                        </Input>
                                                                                    ) : (
                                                                                        <Input
                                                                                            name={`llcOnlyMembers[${index}].state`}
                                                                                            placeholder="State / Province"
                                                                                            value={member.state}
                                                                                            onChange={(e) => {
                                                                                                const newMembers = [...(formik.values.llcOnlyMembers || [])];
                                                                                                newMembers[index].state = e.target.value;
                                                                                                formik.setFieldValue("llcOnlyMembers", newMembers);
                                                                                            }}
                                                                                            onBlur={formik.handleBlur}
                                                                                            invalid={!!(formik.touched.llcOnlyMembers?.[index]?.state && (formik.errors.llcOnlyMembers as any)?.[index]?.state)}
                                                                                        />
                                                                                    )}
                                                                                    <FormFeedback>{(formik.errors.llcOnlyMembers as any)?.[index]?.state}</FormFeedback>
                                                                                </FormGroup>
                                                                            </Col>
                                                                            <Col md={6}>
                                                                                <FormGroup>
                                                                                    <Label>Zip <span className="text-danger">*</span></Label>
                                                                                    <Input
                                                                                        type="text"
                                                                                        name={`llcOnlyMembers[${index}].zip`}
                                                                                        placeholder="12345"
                                                                                        value={member.zip}
                                                                                        onChange={(e) => {
                                                                                            const newMembers = [...(formik.values.llcOnlyMembers || [])];
                                                                                            newMembers[index].zip = e.target.value;
                                                                                            formik.setFieldValue("llcOnlyMembers", newMembers);
                                                                                        }}
                                                                                        onBlur={formik.handleBlur}
                                                                                        invalid={!!(formik.touched.llcOnlyMembers?.[index]?.zip && (formik.errors.llcOnlyMembers as any)?.[index]?.zip)}
                                                                                    />
                                                                                    <FormFeedback>{(formik.errors.llcOnlyMembers as any)?.[index]?.zip}</FormFeedback>
                                                                                </FormGroup>
                                                                            </Col>
                                                                        </Row>
                                                                        
                                                                        <Row>
                                                                            <Col md={6}>
                                                                                <FormGroup>
                                                                                    <Label>
                                                                                        Ownership Percentage <span className="text-danger">*</span>
                                                                                        <i className="bx bx-info-circle ms-2" id={`percentageOwnership-tooltip-${index}`} style={{ cursor: 'help' }}></i>
                                                                                        <UncontrolledTooltip placement="top" target={`percentageOwnership-tooltip-${index}`}>
                                                                                            First member's ownership percentage (0-100). Total ownership for all members must equal exactly 100%.
                                                                                        </UncontrolledTooltip>
                                                                                    </Label>
                                                                                    <Input
                                                                                        name={`llcOnlyMembers[${index}].percentageOwnership`}
                                                                                        type="number"
                                                                                        min="0"
                                                                                        max="100"
                                                                                        value={member.percentageOwnership}
                                                                                        onChange={(e) => {
                                                                                            const newMembers = [...(formik.values.llcOnlyMembers || [])];
                                                                                            newMembers[index].percentageOwnership = e.target.value;
                                                                                            formik.setFieldValue("llcOnlyMembers", newMembers);
                                                                                        }}
                                                                                        onBlur={formik.handleBlur}
                                                                                        invalid={!!(formik.touched.llcOnlyMembers?.[index]?.percentageOwnership && (formik.errors.llcOnlyMembers as any)?.[index]?.percentageOwnership)}
                                                                                    />
                                                                                    <FormFeedback>{(formik.errors.llcOnlyMembers as any)?.[index]?.percentageOwnership}</FormFeedback>
                                                                                </FormGroup>
                                                                            </Col>
                                                                            <Col md={6}>
                                                                                <FormGroup>
                                                                                    <Label>
                                                                                        Item Contributed
                                                                                        <i className="bx bx-info-circle ms-2" id={`itemContributed-tooltip-${index}`} style={{ cursor: 'help' }}></i>
                                                                                        <UncontrolledTooltip placement="top" target={`itemContributed-tooltip-${index}`}>
                                                                                            Type of contribution (typically 'Cash')
                                                                                        </UncontrolledTooltip>
                                                                                    </Label>
                                                                                    <Input
                                                                                        name={`llcOnlyMembers[${index}].itemContributed`}
                                                                                        value={member.itemContributed}
                                                                                        onChange={(e) => {
                                                                                            const newMembers = [...(formik.values.llcOnlyMembers || [])];
                                                                                            newMembers[index].itemContributed = e.target.value;
                                                                                            formik.setFieldValue("llcOnlyMembers", newMembers);
                                                                                        }}
                                                                                        onBlur={formik.handleBlur}
                                                                                        invalid={!!(formik.touched.llcOnlyMembers?.[index]?.itemContributed && (formik.errors.llcOnlyMembers as any)?.[index]?.itemContributed)}
                                                                                    />
                                                                                    <FormFeedback>{(formik.errors.llcOnlyMembers as any)?.[index]?.itemContributed}</FormFeedback>
                                                                                </FormGroup>
                                                                            </Col>
                                                                        </Row>
                                                                        
                                                                        <Row>
                                                                            <Col md={6}>
                                                                                <FormGroup>
                                                                                    <Label>
                                                                                        Market Value of Contribution
                                                                                        <i className="bx bx-info-circle ms-2" id={`itemContributerMarketValue-tooltip-${index}`} style={{ cursor: 'help' }}></i>
                                                                                        <UncontrolledTooltip placement="top" target={`itemContributerMarketValue-tooltip-${index}`}>
                                                                                            Market value of the contribution made by this member (e.g., cash amount, property value)
                                                                                        </UncontrolledTooltip>
                                                                                    </Label>
                                                                                    <Input
                                                                                        name={`llcOnlyMembers[${index}].itemContributerMarketValue`}
                                                                                        type="number"
                                                                                        min="0"
                                                                                        value={member.itemContributerMarketValue}
                                                                                        onChange={(e) => {
                                                                                            const newMembers = [...(formik.values.llcOnlyMembers || [])];
                                                                                            newMembers[index].itemContributerMarketValue = e.target.value;
                                                                                            formik.setFieldValue("llcOnlyMembers", newMembers);
                                                                                        }}
                                                                                        onBlur={formik.handleBlur}
                                                                                        invalid={!!(formik.touched.llcOnlyMembers?.[index]?.itemContributerMarketValue && (formik.errors.llcOnlyMembers as any)?.[index]?.itemContributerMarketValue)}
                                                                                    />
                                                                                    <FormFeedback>{(formik.errors.llcOnlyMembers as any)?.[index]?.itemContributerMarketValue}</FormFeedback>
                                                                                </FormGroup>
                                                                            </Col>
                                                                        </Row>
                                                                    </div>
                                                                ))}
                                                                
                                                                {/* Helpful Note */}
                                                                <div className="mt-3 p-3 bg-info bg-opacity-10 border border-info rounded">
                                                                    <small className="text-info">
                                                                        <i className="bx bx-info-circle"></i> <strong>Note:</strong> The total ownership percentage for all members must equal exactly 100%. 
                                                                        Each member's percentage should be greater than 0% and less than or equal to 100%.
                                                                    </small>
                                                                </div>
                                                            </CardBody>
                                                        </Card>
                                                    </Col>
                                                </Row>
                                                
                                                <Row>
                                                    <Col xs={12}>
                                                        <Card className="mb-4">
                                                            <CardBody>
                                                                <h6 className="fw-bold mb-3">LLC Organizer Information</h6>
                                                                <Row>
                                                                    <Col md={6}>
                                                                        <FormGroup>
                                                                            <Label>
                                                                                Organizer Type
                                                                                <i className="bx bx-info-circle ms-2" id="llcOnlyOrganizer-tooltip" style={{ cursor: 'help' }}></i>
                                                                                <UncontrolledTooltip placement="top" target="llcOnlyOrganizer-tooltip">
                                                                                    Organizer name/type. Required for specific states (NC, GA, MA, NH, WI). The organizer is the person or entity that forms the LLC.
                                                                                </UncontrolledTooltip>
                                                                            </Label>
                                                                            <Input
                                                                                name="llcOnlyOrganizer"
                                                                                placeholder="Example: Incorporator"
                                                                                value={formik.values.llcOnlyOrganizer}
                                                                                onChange={formik.handleChange}
                                                                                onBlur={formik.handleBlur}
                                                                                invalid={!!(formik.touched.llcOnlyOrganizer && formik.errors.llcOnlyOrganizer)}
                                                                            />
                                                                            <FormFeedback>{formik.errors.llcOnlyOrganizer}</FormFeedback>
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col md={6}>
                                                                        <FormGroup>
                                                                            <Label>Organizer First Name <span className="text-danger">*</span></Label>
                                                                            <Input
                                                                                name="llcOnlyOrganizerFirstName"
                                                                                value={formik.values.llcOnlyOrganizerFirstName}
                                                                                onChange={formik.handleChange}
                                                                                onBlur={formik.handleBlur}
                                                                                invalid={!!(formik.touched.llcOnlyOrganizerFirstName && formik.errors.llcOnlyOrganizerFirstName)}
                                                                            />
                                                                            <FormFeedback>{formik.errors.llcOnlyOrganizerFirstName}</FormFeedback>
                                                                        </FormGroup>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col md={6}>
                                                                        <FormGroup>
                                                                            <Label>Organizer Last Name <span className="text-danger">*</span></Label>
                                                                            <Input
                                                                                name="llcOnlyOrganizerLastName"
                                                                                value={formik.values.llcOnlyOrganizerLastName}
                                                                                onChange={formik.handleChange}
                                                                                onBlur={formik.handleBlur}
                                                                                invalid={!!(formik.touched.llcOnlyOrganizerLastName && formik.errors.llcOnlyOrganizerLastName)}
                                                                            />
                                                                            <FormFeedback>{formik.errors.llcOnlyOrganizerLastName}</FormFeedback>
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col md={6}>
                                                                        <FormGroup>
                                                                            <Label>Country <span className="text-danger">*</span></Label>
                                                                            <Input
                                                                                type="select"
                                                                                name="llcOnlyOrganizerCountry"
                                                                                value={formik.values.llcOnlyOrganizerCountry}
                                                                                onChange={(e) => handleCountryChange("llcOnlyOrganizerCountry", "llcOnlyOrganizerState", e.target.value)}
                                                                                onBlur={formik.handleBlur}
                                                                                invalid={!!(formik.touched.llcOnlyOrganizerCountry && formik.errors.llcOnlyOrganizerCountry)}
                                                                            >
                                                                                <option value="">Select country</option>
                                                                                {COUNTRY_OPTIONS.map((country) => (
                                                                                    <option key={country.code} value={country.code}>
                                                                                        {country.label}
                                                                                    </option>
                                                                                ))}
                                                                            </Input>
                                                                            <FormFeedback>{formik.errors.llcOnlyOrganizerCountry}</FormFeedback>
                                                                        </FormGroup>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col md={6}>
                                                                        <FormGroup>
                                                                            <Label>Address 1 <span className="text-danger">*</span></Label>
                                                                            <Input
                                                                                name="llcOnlyOrganizerAddress1"
                                                                                value={formik.values.llcOnlyOrganizerAddress1}
                                                                                onChange={formik.handleChange}
                                                                                onBlur={formik.handleBlur}
                                                                                invalid={!!(formik.touched.llcOnlyOrganizerAddress1 && formik.errors.llcOnlyOrganizerAddress1)}
                                                                            />
                                                                            <FormFeedback>{formik.errors.llcOnlyOrganizerAddress1}</FormFeedback>
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col md={6}>
                                                                        <FormGroup>
                                                                            <Label>Address 2</Label>
                                                                            <Input
                                                                                name="llcOnlyOrganizerAddress2"
                                                                                value={formik.values.llcOnlyOrganizerAddress2}
                                                                                onChange={formik.handleChange}
                                                                                onBlur={formik.handleBlur}
                                                                                invalid={!!(formik.touched.llcOnlyOrganizerAddress2 && formik.errors.llcOnlyOrganizerAddress2)}
                                                                            />
                                                                            <FormFeedback>{formik.errors.llcOnlyOrganizerAddress2}</FormFeedback>
                                                                        </FormGroup>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col md={6}>
                                                                        <FormGroup>
                                                                            <Label>City <span className="text-danger">*</span></Label>
                                                                            <Input
                                                                                name="llcOnlyOrganizerCity"
                                                                                value={formik.values.llcOnlyOrganizerCity}
                                                                                onChange={formik.handleChange}
                                                                                onBlur={formik.handleBlur}
                                                                                invalid={!!(formik.touched.llcOnlyOrganizerCity && formik.errors.llcOnlyOrganizerCity)}
                                                                            />
                                                                            <FormFeedback>{formik.errors.llcOnlyOrganizerCity}</FormFeedback>
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col md={6}>
                                                                        <FormGroup>
                                                                            <Label>State <span className="text-danger">*</span></Label>
                                                                            {formik.values.llcOnlyOrganizerCountry === DEFAULT_COUNTRY ? (
                                                                                <Input
                                                                                    type="select"
                                                                                    name="llcOnlyOrganizerState"
                                                                                    value={formik.values.llcOnlyOrganizerState}
                                                                                    onChange={formik.handleChange}
                                                                                    onBlur={formik.handleBlur}
                                                                                    invalid={!!(formik.touched.llcOnlyOrganizerState && formik.errors.llcOnlyOrganizerState)}
                                                                                >
                                                                                    <option value="">Select state</option>
                                                                                    {US_STATES.map((state) => (
                                                                                        <option key={state.value} value={state.value}>
                                                                                            {state.label}
                                                                                        </option>
                                                                                    ))}
                                                                                </Input>
                                                                            ) : (
                                                                                <Input
                                                                                    name="llcOnlyOrganizerState"
                                                                                    placeholder="State / Province"
                                                                                    value={formik.values.llcOnlyOrganizerState}
                                                                                    onChange={formik.handleChange}
                                                                                    onBlur={formik.handleBlur}
                                                                                    invalid={!!(formik.touched.llcOnlyOrganizerState && formik.errors.llcOnlyOrganizerState)}
                                                                                />
                                                                            )}
                                                                            <FormFeedback>{formik.errors.llcOnlyOrganizerState}</FormFeedback>
                                                                        </FormGroup>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col md={6}>
                                                                        <FormGroup>
                                                                            <Label>Zip <span className="text-danger">*</span></Label>
                                                                            <Input
                                                                                type="text"
                                                                                name="llcOnlyOrganizerZip"
                                                                                placeholder="12345"
                                                                                value={formik.values.llcOnlyOrganizerZip}
                                                                                onChange={formik.handleChange}
                                                                                onBlur={formik.handleBlur}
                                                                                invalid={!!(formik.touched.llcOnlyOrganizerZip && formik.errors.llcOnlyOrganizerZip)}
                                                                            />
                                                                            <FormFeedback>{formik.errors.llcOnlyOrganizerZip}</FormFeedback>
                                                                        </FormGroup>
                                                                    </Col>
                                                                </Row>
                                                            </CardBody>
                                                        </Card>
                                                    </Col>
                                                </Row>
                                            </>
                                        )}
                                        
                                        {/* Nonprofit Incorporator Section - Only show for Non-Profit Corporation */}
                                        {businessStructureType === "Non-Profit Corporation" && (
                                            <Row>
                                                <Col xs={12}>
                                                    <Card className="mb-4">
                                                        <CardBody>
                                                            <h6 className="fw-bold mb-3">Nonprofit Incorporator Information</h6>
                                                            <Row>
                                                                <Col md={6}>
                                                                    <FormGroup>
                                                                        <Label>Incorporator First Name <span className="text-danger">*</span></Label>
                                                                        <Input
                                                                            name="nonprofitIncorporatorFirstName"
                                                                            value={formik.values.nonprofitIncorporatorFirstName}
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                            invalid={!!(formik.touched.nonprofitIncorporatorFirstName && formik.errors.nonprofitIncorporatorFirstName)}
                                                                        />
                                                                        <FormFeedback>{formik.errors.nonprofitIncorporatorFirstName}</FormFeedback>
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col md={6}>
                                                                    <FormGroup>
                                                                        <Label>Incorporator Last Name <span className="text-danger">*</span></Label>
                                                                        <Input
                                                                            name="nonprofitIncorporatorLastName"
                                                                            value={formik.values.nonprofitIncorporatorLastName}
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                            invalid={!!(formik.touched.nonprofitIncorporatorLastName && formik.errors.nonprofitIncorporatorLastName)}
                                                                        />
                                                                        <FormFeedback>{formik.errors.nonprofitIncorporatorLastName}</FormFeedback>
                                                                    </FormGroup>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col md={6}>
                                                                    <FormGroup>
                                                                        <Label>Country <span className="text-danger">*</span></Label>
                                                                        <Input
                                                                            type="select"
                                                                            name="nonprofitIncorporatorCountry"
                                                                            value={formik.values.nonprofitIncorporatorCountry}
                                                                            onChange={(e) => handleCountryChange("nonprofitIncorporatorCountry", "nonprofitIncorporatorState", e.target.value)}
                                                                            onBlur={formik.handleBlur}
                                                                            invalid={!!(formik.touched.nonprofitIncorporatorCountry && formik.errors.nonprofitIncorporatorCountry)}
                                                                        >
                                                                            <option value="">Select country</option>
                                                                            {COUNTRY_OPTIONS.map((country) => (
                                                                                <option key={country.code} value={country.code}>
                                                                                    {country.label}
                                                                                </option>
                                                                            ))}
                                                                        </Input>
                                                                        <FormFeedback>{formik.errors.nonprofitIncorporatorCountry}</FormFeedback>
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col md={6}>
                                                                    <FormGroup>
                                                                        <Label>Address 1 <span className="text-danger">*</span></Label>
                                                                        <Input
                                                                            name="nonprofitIncorporatorAddress1"
                                                                            value={formik.values.nonprofitIncorporatorAddress1}
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                            invalid={!!(formik.touched.nonprofitIncorporatorAddress1 && formik.errors.nonprofitIncorporatorAddress1)}
                                                                        />
                                                                        <FormFeedback>{formik.errors.nonprofitIncorporatorAddress1}</FormFeedback>
                                                                    </FormGroup>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col md={6}>
                                                                    <FormGroup>
                                                                        <Label>Address 2</Label>
                                                                        <Input
                                                                            name="nonprofitIncorporatorAddress2"
                                                                            value={formik.values.nonprofitIncorporatorAddress2}
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                            invalid={!!(formik.touched.nonprofitIncorporatorAddress2 && formik.errors.nonprofitIncorporatorAddress2)}
                                                                        />
                                                                        <FormFeedback>{formik.errors.nonprofitIncorporatorAddress2}</FormFeedback>
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col md={6}>
                                                                    <FormGroup>
                                                                        <Label>City <span className="text-danger">*</span></Label>
                                                                        <Input
                                                                            name="nonprofitIncorporatorCity"
                                                                            value={formik.values.nonprofitIncorporatorCity}
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                            invalid={!!(formik.touched.nonprofitIncorporatorCity && formik.errors.nonprofitIncorporatorCity)}
                                                                        />
                                                                        <FormFeedback>{formik.errors.nonprofitIncorporatorCity}</FormFeedback>
                                                                    </FormGroup>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col md={6}>
                                                                    <FormGroup>
                                                                        <Label>State <span className="text-danger">*</span></Label>
                                                                        {formik.values.nonprofitIncorporatorCountry === DEFAULT_COUNTRY ? (
                                                                            <Input
                                                                                type="select"
                                                                                name="nonprofitIncorporatorState"
                                                                                value={formik.values.nonprofitIncorporatorState}
                                                                                onChange={formik.handleChange}
                                                                                onBlur={formik.handleBlur}
                                                                                invalid={!!(formik.touched.nonprofitIncorporatorState && formik.errors.nonprofitIncorporatorState)}
                                                                            >
                                                                                <option value="">Select state</option>
                                                                                {US_STATES.map((state) => (
                                                                                    <option key={state.value} value={state.value}>
                                                                                        {state.label}
                                                                                    </option>
                                                                                ))}
                                                                            </Input>
                                                                        ) : (
                                                                            <Input
                                                                                name="nonprofitIncorporatorState"
                                                                                placeholder="State / Province"
                                                                                value={formik.values.nonprofitIncorporatorState}
                                                                                onChange={formik.handleChange}
                                                                                onBlur={formik.handleBlur}
                                                                                invalid={!!(formik.touched.nonprofitIncorporatorState && formik.errors.nonprofitIncorporatorState)}
                                                                            />
                                                                        )}
                                                                        <FormFeedback>{formik.errors.nonprofitIncorporatorState}</FormFeedback>
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col md={6}>
                                                                    <FormGroup>
                                                                        <Label>Zip <span className="text-danger">*</span></Label>
                                                                        <Input
                                                                            type="text"
                                                                            name="nonprofitIncorporatorZip"
                                                                            placeholder="12345"
                                                                            value={formik.values.nonprofitIncorporatorZip}
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                            invalid={!!(formik.touched.nonprofitIncorporatorZip && formik.errors.nonprofitIncorporatorZip)}
                                                                        />
                                                                        <FormFeedback>{formik.errors.nonprofitIncorporatorZip}</FormFeedback>
                                                                    </FormGroup>
                                                                </Col>
                                                            </Row>
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                            </Row>
                                        )}
                                        
                                        {/* Corporation Specific Section - Only show for Corporations */}
                                        {(businessStructureType === "C-Corporation" || businessStructureType === "S-Corporation" || businessStructureType === "Professional Corporation") && (
                                            <Row>
                                                <Col xs={12}>
                                                    <Card className="mb-4">
                                                        <CardBody>
                                                            <h6 className="fw-bold mb-3">Corporation Information</h6>
                                                            <Row>
                                                                <Col md={6}>
                                                                    <FormGroup>
                                                                        <Label>
                                                                            Authorized Shares <span className="text-danger">*</span>
                                                                            <i className="bx bx-info-circle ms-2" id="corporationsOnlyAuthorizedShares-tooltip" style={{ cursor: 'help' }}></i>
                                                                            <UncontrolledTooltip placement="top" target="corporationsOnlyAuthorizedShares-tooltip">
                                                                                Number of authorized shares. This is the maximum number of shares the corporation is allowed to issue. Common values are 1,000, 10,000, or 1,000,000.
                                                                            </UncontrolledTooltip>
                                                                        </Label>
                                                                        <Input
                                                                            name="corporationsOnlyAuthorizedShares"
                                                                            type="number"
                                                                            min="1"
                                                                            value={formik.values.corporationsOnlyAuthorizedShares}
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                            invalid={!!(formik.touched.corporationsOnlyAuthorizedShares && formik.errors.corporationsOnlyAuthorizedShares)}
                                                                        />
                                                                        <FormFeedback>{formik.errors.corporationsOnlyAuthorizedShares}</FormFeedback>
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col md={6}>
                                                                    <FormGroup>
                                                                        <Label>
                                                                            Par Value
                                                                            <i className="bx bx-info-circle ms-2" id="corporationOnlyParValue-tooltip" style={{ cursor: 'help' }}></i>
                                                                            <UncontrolledTooltip placement="top" target="corporationOnlyParValue-tooltip">
                                                                                Par value per share. This is the minimum price at which shares can be issued. Common values are $0.01, $0.001, or $1.00. Many corporations use a low par value like $0.01.
                                                                            </UncontrolledTooltip>
                                                                        </Label>
                                                                        <Input
                                                                            name="corporationOnlyParValue"
                                                                            type="number"
                                                                            min="0"
                                                                            step="0.01"
                                                                            value={formik.values.corporationOnlyParValue}
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                            invalid={!!(formik.touched.corporationOnlyParValue && formik.errors.corporationOnlyParValue)}
                                                                        />
                                                                        <FormFeedback>{formik.errors.corporationOnlyParValue}</FormFeedback>
                                                                    </FormGroup>
                                                                </Col>
                                                            </Row>
                                                            
                                                            <h6 className="fw-bold mb-3 mt-4">Director Information</h6>
                                                            <Row>
                                                                <Col md={6}>
                                                                    <FormGroup>
                                                                        <Label>Director Country <span className="text-danger">*</span></Label>
                                                                        <Input
                                                                            type="select"
                                                                            name="corporationOnlyDirector1InfoCountry"
                                                                            value={formik.values.corporationOnlyDirector1InfoCountry}
                                                                            onChange={(e) => handleCountryChange("corporationOnlyDirector1InfoCountry", "corporationOnlyDirector1InfoState", e.target.value)}
                                                                            onBlur={formik.handleBlur}
                                                                            invalid={!!(formik.touched.corporationOnlyDirector1InfoCountry && formik.errors.corporationOnlyDirector1InfoCountry)}
                                                                        >
                                                                            <option value="">Select country</option>
                                                                            {COUNTRY_OPTIONS.map((country) => (
                                                                                <option key={country.code} value={country.code}>
                                                                                    {country.label}
                                                                                </option>
                                                                            ))}
                                                                        </Input>
                                                                        <FormFeedback>{formik.errors.corporationOnlyDirector1InfoCountry}</FormFeedback>
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col md={6}>
                                                                    <FormGroup>
                                                                        <Label>Director Address 1 <span className="text-danger">*</span></Label>
                                                                        <Input
                                                                            name="corporationOnlyDirector1InfoAddress1"
                                                                            value={formik.values.corporationOnlyDirector1InfoAddress1}
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                            invalid={!!(formik.touched.corporationOnlyDirector1InfoAddress1 && formik.errors.corporationOnlyDirector1InfoAddress1)}
                                                                        />
                                                                        <FormFeedback>{formik.errors.corporationOnlyDirector1InfoAddress1}</FormFeedback>
                                                                    </FormGroup>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col md={6}>
                                                                    <FormGroup>
                                                                        <Label>Director Address 2</Label>
                                                                        <Input
                                                                            name="corporationOnlyDirector1InfoAddress2"
                                                                            value={formik.values.corporationOnlyDirector1InfoAddress2}
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                            invalid={!!(formik.touched.corporationOnlyDirector1InfoAddress2 && formik.errors.corporationOnlyDirector1InfoAddress2)}
                                                                        />
                                                                        <FormFeedback>{formik.errors.corporationOnlyDirector1InfoAddress2}</FormFeedback>
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col md={6}>
                                                                    <FormGroup>
                                                                        <Label>Director City <span className="text-danger">*</span></Label>
                                                                        <Input
                                                                            name="corporationOnlyDirector1InfoCity"
                                                                            value={formik.values.corporationOnlyDirector1InfoCity}
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                            invalid={!!(formik.touched.corporationOnlyDirector1InfoCity && formik.errors.corporationOnlyDirector1InfoCity)}
                                                                        />
                                                                        <FormFeedback>{formik.errors.corporationOnlyDirector1InfoCity}</FormFeedback>
                                                                    </FormGroup>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col md={6}>
                                                                    <FormGroup>
                                                                        <Label>Director State <span className="text-danger">*</span></Label>
                                                                        {formik.values.corporationOnlyDirector1InfoCountry === DEFAULT_COUNTRY ? (
                                                                            <Input
                                                                                type="select"
                                                                                name="corporationOnlyDirector1InfoState"
                                                                                value={formik.values.corporationOnlyDirector1InfoState}
                                                                                onChange={formik.handleChange}
                                                                                onBlur={formik.handleBlur}
                                                                                invalid={!!(formik.touched.corporationOnlyDirector1InfoState && formik.errors.corporationOnlyDirector1InfoState)}
                                                                            >
                                                                                <option value="">Select state</option>
                                                                                {US_STATES.map((state) => (
                                                                                    <option key={state.value} value={state.value}>
                                                                                        {state.label}
                                                                                    </option>
                                                                                ))}
                                                                            </Input>
                                                                        ) : (
                                                                            <Input
                                                                                name="corporationOnlyDirector1InfoState"
                                                                                placeholder="State / Province"
                                                                                value={formik.values.corporationOnlyDirector1InfoState}
                                                                                onChange={formik.handleChange}
                                                                                onBlur={formik.handleBlur}
                                                                                invalid={!!(formik.touched.corporationOnlyDirector1InfoState && formik.errors.corporationOnlyDirector1InfoState)}
                                                                            />
                                                                        )}
                                                                        <FormFeedback>{formik.errors.corporationOnlyDirector1InfoState}</FormFeedback>
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col md={6}>
                                                                    <FormGroup>
                                                                        <Label>Director Zip <span className="text-danger">*</span></Label>
                                                                        <Input
                                                                            type="text"
                                                                            name="corporationOnlyDirector1InfoZip"
                                                                            placeholder="12345"
                                                                            value={formik.values.corporationOnlyDirector1InfoZip}
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                            invalid={!!(formik.touched.corporationOnlyDirector1InfoZip && formik.errors.corporationOnlyDirector1InfoZip)}
                                                                        />
                                                                        <FormFeedback>{formik.errors.corporationOnlyDirector1InfoZip}</FormFeedback>
                                                                    </FormGroup>
                                                                </Col>
                                                            </Row>
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                            </Row>
                                        )}
                                        
                                        {/* Responsible Party Section - Always show */}
                                        <Row>
                                            <Col xs={12}>
                                                <Card className="mb-4">
                                                    <CardBody>
                                                        <h6 className="fw-bold mb-3">Responsible Party Information</h6>
                                                        <Row>
                                                            <Col md={6}>
                                                                <FormGroup>
                                                                    <Label>
                                                                        Role <span className="text-danger">*</span>
                                                                        <i className="bx bx-info-circle ms-2" id="responsibleParty-tooltip" style={{ cursor: 'help' }}></i>
                                                                        <UncontrolledTooltip placement="top" target="responsibleParty-tooltip">
                                                                            Type of responsible party for tax purposes. This person has significant responsibility for managing or directing the entity.
                                                                        </UncontrolledTooltip>
                                                                    </Label>
                                                                    <Input
                                                                        name="responsibleParty"
                                                                        type="select"
                                                                        value={formik.values.responsibleParty}
                                                                        onChange={formik.handleChange}
                                                                        onBlur={formik.handleBlur}
                                                                        invalid={!!(formik.touched.responsibleParty && formik.errors.responsibleParty)}
                                                                    >
                                                                        <option value="">Select Role</option>
                                                                        {businessStructureType === "LLC" && <option value="Member">Member</option>}
                                                                        {businessStructureType === "LLC" && <option value="Manager">Manager</option>}
                                                                        {businessStructureType !== "LLC" && <option value="Director">Director</option>}
                                                                        {businessStructureType !== "LLC" && <option value="President">President</option>}
                                                                        {businessStructureType !== "LLC" && <option value="Secretary">Secretary</option>}
                                                                        {businessStructureType !== "LLC" && <option value="Treasurer">Treasurer</option>}
                                                                    </Input>
                                                                    <FormFeedback>{formik.errors.responsibleParty}</FormFeedback>
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={6}>
                                                                <FormGroup>
                                                                    <Label>First Name <span className="text-danger">*</span></Label>
                                                                    <Input
                                                                        name="responsiblePartyFirstName"
                                                                        value={formik.values.responsiblePartyFirstName}
                                                                        onChange={formik.handleChange}
                                                                        onBlur={formik.handleBlur}
                                                                        invalid={!!(formik.touched.responsiblePartyFirstName && formik.errors.responsiblePartyFirstName)}
                                                                    />
                                                                    <FormFeedback>{formik.errors.responsiblePartyFirstName}</FormFeedback>
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col md={6}>
                                                                <FormGroup>
                                                                    <Label>Middle Name</Label>
                                                                    <Input
                                                                        name="responsiblePartyMiddleName"
                                                                        value={formik.values.responsiblePartyMiddleName}
                                                                        onChange={formik.handleChange}
                                                                        onBlur={formik.handleBlur}
                                                                        invalid={!!(formik.touched.responsiblePartyMiddleName && formik.errors.responsiblePartyMiddleName)}
                                                                    />
                                                                    <FormFeedback>{formik.errors.responsiblePartyMiddleName}</FormFeedback>
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={6}>
                                                                <FormGroup>
                                                                    <Label>Last Name <span className="text-danger">*</span></Label>
                                                                    <Input
                                                                        name="responsiblePartyLastName"
                                                                        value={formik.values.responsiblePartyLastName}
                                                                        onChange={formik.handleChange}
                                                                        onBlur={formik.handleBlur}
                                                                        invalid={!!(formik.touched.responsiblePartyLastName && formik.errors.responsiblePartyLastName)}
                                                                    />
                                                                    <FormFeedback>{formik.errors.responsiblePartyLastName}</FormFeedback>
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col md={6}>
                                                                <FormGroup>
                                                                    <Label>Email</Label>
                                                                    <Input
                                                                        name="responsiblePartyEmail"
                                                                        type="email"
                                                                        value={formik.values.responsiblePartyEmail}
                                                                        onChange={formik.handleChange}
                                                                        onBlur={formik.handleBlur}
                                                                        invalid={!!(formik.touched.responsiblePartyEmail && formik.errors.responsiblePartyEmail)}
                                                                    />
                                                                    <FormFeedback>{formik.errors.responsiblePartyEmail}</FormFeedback>
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={6}>
                                                                <FormGroup>
                                                                    <Label>
                                                                        Has SSN? <span className="text-danger">*</span>
                                                                        <i className="bx bx-info-circle ms-2" id="responsiblePartyStatus-tooltip" style={{ cursor: 'help' }}></i>
                                                                        <UncontrolledTooltip placement="top" target="responsiblePartyStatus-tooltip">
                                                                            Whether the responsible party has a Social Security Number. Required for tax identification purposes. If Yes, SSN and email are required.
                                                                        </UncontrolledTooltip>
                                                                    </Label>
                                                                    <Input
                                                                        name="responsiblePartyStatus"
                                                                        type="select"
                                                                        value={formik.values.responsiblePartyStatus}
                                                                        onChange={formik.handleChange}
                                                                        onBlur={formik.handleBlur}
                                                                        invalid={!!(formik.touched.responsiblePartyStatus && formik.errors.responsiblePartyStatus)}
                                                                    >
                                                                        <option value="">Select</option>
                                                                        <option value="Yes">Yes</option>
                                                                        <option value="No">No</option>
                                                                    </Input>
                                                                    <FormFeedback>{formik.errors.responsiblePartyStatus}</FormFeedback>
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        {formik.values.responsiblePartyStatus === "Yes" && (
                                                            <Row>
                                                                <Col md={6}>
                                                                    <FormGroup>
                                                                        <Label>SSN <span className="text-danger">*</span></Label>
                                                                        <Input
                                                                            name="responsiblePartySSN"
                                                                            placeholder="123456789"
                                                                            maxLength={9}
                                                                            value={formik.values.responsiblePartySSN}
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                            invalid={!!(formik.touched.responsiblePartySSN && formik.errors.responsiblePartySSN)}
                                                                        />
                                                                        <FormFeedback>{formik.errors.responsiblePartySSN}</FormFeedback>
                                                                    </FormGroup>
                                                                </Col>
                                                            </Row>
                                                        )}
                                                    </CardBody>
                                                </Card>
                                            </Col>
                                        </Row>
                                        {checkoutDisclaimer && (
                                            <div className="form-check mt-3">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id="cfDisclaimerCheckbox"
                                                    checked={disclaimerAccepted}
                                                    onChange={(e) => setDisclaimerAccepted(e.target.checked)}
                                                />
                                                <label className="form-check-label" htmlFor="cfDisclaimerCheckbox">
                                                    {checkoutDisclaimer.text} <span className="text-danger">*</span>
                                                </label>
                                            </div>
                                        )}
                                        <div className="mt-4 text-end">
                                            <Button color="secondary" type="button" onClick={onClose} className="me-2">
                                                Cancel
                                            </Button>
                                            <Button color="primary" type="submit" disabled={formik.isSubmitting || (!!checkoutDisclaimer && !disclaimerAccepted)}>
                                                {formik.isSubmitting ? "Submitting..." : "Submit"}
                                            </Button>
                                        </div>
                                    </Form>
                                </>
                            )}
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
        <style dangerouslySetInnerHTML={{
            __html: `
                @keyframes float {
                    0% {
                        transform: translateY(0px);
                    }
                    50% {
                        transform: translateY(-10px);
                    }
                    100% {
                        transform: translateY(0px);
                    }
                }
                
                @keyframes slideIn {
                    from {
                        opacity: 0;
                        transform: translateY(-10px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
                
                @keyframes spin {
                    0% {
                        transform: rotate(0deg);
                    }
                    100% {
                        transform: rotate(360deg);
                    }
                }
            `
        }} />
        </>
    );
};
